<template>
    <div class="d-flex flex-column">
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        
        <div v-if="gridCanMount" class="h-100 d-flex flex-column">

        <transition name="fade" mode="out-in">
        
            <div v-if="loading">
                <busy-spinner text="Loading..."></busy-spinner>
            </div>
            
            <div v-else-if="hasReplies" class="py-2 d-flex gap-3 justify-content-between align-items-end">
                <div style="">
                    <h4 class="mb-0">{{ title }}</h4>
                </div>
                <div v-if="hasReplies" class="d-flex flex-wrap justify-content-end gap-2">  <!-- BUTTONS / TOOLBAR -->
                    <!-- <b-button-group v-if="$currentUserInfo.user_is_staff" size="sm" class="">
                        <b-button variant="subtle-primary" @click="dumpGrid">Dump Grid</b-button>
                        <b-button variant="subtle-primary" @click="updateRowHeights">updateRowHeights</b-button>
                    </b-button-group> -->
                    <!-- <b-button-group size="sm" class="">
                        <b-button :disabled="!hasMultipleRepliesPerCompany" variant="subtle-primary" @click="showAllReplies">Show All</b-button>
                        <b-button :disabled="!hasMultipleRepliesPerCompany" variant="subtle-primary" @click="showLatestReplies">Show Latest</b-button>
                    </b-button-group> -->
                    <!-- <b-button-group size="sm" class="">
                        <b-button variant="subtle-primary" v-b-toggle.compare-grid-toggles-area>
                            <b-icon icon="layout-three-columns" class="mr-1"></b-icon>
                            Open Column Picker
                        </b-button>
                    </b-button-group> -->
                    <!-- <b-button-group size="sm" class="">
                        <b-button variant="subtle-primary" @click="resetColumns"><b-icon icon="arrow-counterclockwise" class="mr-1"></b-icon>Reset Columns</b-button>
                        <b-button variant="subtle-primary" @click="sizeColumnsToFit"><b-icon icon="arrow-left-short"></b-icon><b-icon icon="arrow-right-short" class="mr-1"></b-icon>Fit Columns</b-button>
                    </b-button-group> -->
                    <b-button-group size="sm" class="">
                        <b-button variant="subtle-primary" @click="exportExcel"><b-icon icon="file-earmark-excel" class="mr-1"></b-icon>{{ isSmartForm ? 'Export Current Grid' : 'Export to Excel' }}</b-button>
                    </b-button-group>
                    <b-button-group v-if="isSmartForm && smartFormData.id" size="sm" class="">
                        <b-button :disabled="isDownloadingSmartFormReplies" variant="subtle-primary" @click="downloadSmartFormReplies">
                            <b-icon icon="file-earmark-excel" class="mr-1"></b-icon>{{ isDownloadingSmartFormReplies ? 'Downloading...' : 'Download Full Responses' }}
                        </b-button>
                    </b-button-group>
                    <!-- <b-button-group v-if="hasAnalyticsCols" size="sm" class="">
                        <b-button variant="subtle-primary" @click="togglePriceAnalysis">
                            Analysis Columns
                            <span class="mx-1" :class="showPriceAnalysis ? '' : 'text-muted'">ON</span>
                            <span :class="showPriceAnalysis ? 'text-muted' : ''">OFF</span>
                        </b-button>
                    </b-button-group> -->
                </div>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
                <div class="alert alert-warning">
                    No responses from suppliers to show for this item.
                </div>
            </div>
        </transition>

        <div class="mt-2 w-100 flex-fill pb-2" :class="!loading && hasReplies ? 'd-flex gap-3' : 'd-none'" style="min-height: 800px;">  <!-- we had v-show="!loading && hasReplies" - but want to use d-flex, so we just apply d-none conditionally -->
            <div v-if="hasReplies" id="compare-grid-toggles-area" class="company-todo-compare-grid-toggles align-self-start border rounded bg-white overflow-hidden" style="width: 25%; max-width: 250px;">
                <div class="toggle-group bg-primary-100 py-2 pl-3">
                    <h6 class="mb-0">Columns</h6>
                </div>
                <div class="toggle-group d-flex align-items-center justify-content-around py-2 bg-gray-100">
                    <b-button variant="gray-primary" size="sm" @click="resetColumns"><b-icon icon="arrow-counterclockwise" class="mr-1"></b-icon>Reset</b-button>
                    <b-button variant="gray-primary" size="sm" @click="sizeColumnsToFit"><b-icon icon="arrow-left-short"></b-icon><b-icon icon="arrow-right-short" class="mr-1"></b-icon>Fit Width</b-button>
                </div>
                <!-- <hr> -->
                <div v-if="isQuoteSheet" class="toggle-group">
                    <div class="toggle-heading">
                        <b-button 
                            v-b-toggle="'toggle-group-collapse-item-details'"
                            variant="zone-light"
                            class="toggle-group-collapse-button"
                        >
                            <span class="collapse-button-text">Item Details</span>
                            <div class="collapse-button-icon">
                                <b-icon icon="chevron-down" class="when-closed"></b-icon>
                                <b-icon icon="chevron-up" class="when-open"></b-icon>
                            </div>
                        </b-button>
                    </div>
                    <b-collapse id="toggle-group-collapse-item-details" visible class="toggle-group-collapse">
                        <div class="show-hide-links">
                            <b-link href="#" @click="showAllQuoteSheetItemCols" class="show-hide-toggle-link">Show All</b-link>
                            <b-link href="#" :disabled="!quoteSheetVisibleItemColIds.length" @click="hideAllQuoteSheetItemCols" class="show-hide-toggle-link">Hide All</b-link>
                        </div>
                        <b-form-checkbox-group
                            :checked="quoteSheetVisibleItemColIds"
                            :options="quoteSheetAvailableItemCols"
                            @change="handleQuoteSheetVisibleItemColsChange"
                            class="compare-grid-toggle-checkboxes"
                            stacked
                        ></b-form-checkbox-group>  <!-- do not use v-model -- handle change through handler so you know what changed -->
                    </b-collapse>
                </div>
                <!-- <hr v-if="isQuoteSheet"> -->
                <div v-if="isQuoteSheet" class="toggle-group">
                    <div class="toggle-heading">
                        <b-button 
                            v-b-toggle="'toggle-group-collapse-vendor-data'"
                            variant="zone-light"
                            class="toggle-group-collapse-button"
                        >
                            <span class="collapse-button-text">Response Details</span>
                            <div class="collapse-button-icon">
                                <b-icon icon="chevron-down" class="when-closed"></b-icon>
                                <b-icon icon="chevron-up" class="when-open"></b-icon>
                            </div>
                        </b-button>
                    </div>
                    <b-collapse id="toggle-group-collapse-vendor-data" visible class="toggle-group-collapse">
                        <div class="show-hide-links">
                            <b-link href="#" @click="showAllQuoteSheetVendorCols" class="show-hide-toggle-link">Show All</b-link>
                            <b-link href="#" :disabled="!quoteSheetVisibleVendorColIds.length" @click="hideAllQuoteSheetVendorCols" class="show-hide-toggle-link">Hide All</b-link>
                        </div>
                        <b-form-checkbox-group
                            :checked="quoteSheetVisibleVendorColIds"
                            :options="quoteSheetAvailableVendorCols"
                            @change="handleQuoteSheetVisibleVendorColsChange"
                            class="compare-grid-toggle-checkboxes"
                            stacked
                        ></b-form-checkbox-group>  <!-- do not use v-model -- handle change through handler so you know what changed -->
                    </b-collapse>
                </div>
                <!-- <hr v-if="isQuoteSheet"> -->
                <div class="toggle-group">  <!-- show this for ALL types/categories, not just quotesheets -->
                    <div class="toggle-heading">
                        <b-button 
                            v-b-toggle="'toggle-group-collapse-replies'"
                            variant="zone-light"
                            class="toggle-group-collapse-button"
                        >
                            <span class="collapse-button-text">Vendors</span>
                            <div class="collapse-button-icon">
                                <b-icon icon="chevron-down" class="when-closed"></b-icon>
                                <b-icon icon="chevron-up" class="when-open"></b-icon>
                            </div>
                        </b-button>
                    </div>
                    <b-collapse id="toggle-group-collapse-replies" visible class="toggle-group-collapse">
                        <div class="show-hide-links">
                            <b-link v-if="hasMultipleRepliesPerCompany" href="#" @click="showLatestReplies" class="show-hide-toggle-link">Show Latest</b-link>
                            <b-link href="#" @click="showAllReplies" class="show-hide-toggle-link">Show All</b-link>
                            <b-link href="#" :disabled="!visibleReplyIds.length" @click="hideAllReplies" class="show-hide-toggle-link">Hide All</b-link>
                        </div>
                        <b-form-checkbox-group
                            :checked="visibleReplyIds"
                            @change="handleVisibleReplyColsChange"
                            class="compare-grid-toggle-checkboxes"
                            stacked
                        >  <!-- don't specify options in this checkbox-group, instead use v-for explicitly -->
                            <div v-for="comp in availableReplyColsByCompany" :key="comp.companyId" class="mb-1">
                                <b-form-checkbox v-for="rep in comp.replies" :key="rep.value" :value="rep.value" :class="rep.isLatest ? '' : 'ml-4'">
                                    <span class="font-weight-bold" :class="rep.isLatest ? 'font-size-80' : 'font-size-70 text-muted'">{{ rep.isLatest ? rep.companyName : 'PREVIOUS' }}</span>
                                    <span v-if="false" class="ml-2 font-weight-400" :class="rep.isLatest ? 'font-size-80' : 'font-size-70 text-muted'">{{rep.submittedOnString}}</span>
                                    <span v-if="comp.hasMultipleReplies" class="ml-1 font-size-70 font-weight-500" :class="rep.isLatest ? 'text-success' : 'text-muted'">{{ rep.isLatest ? ' LATEST' : rep.submittedOnString }}</span>
                                </b-form-checkbox>
                            </div>
                            <!-- <b-form-checkbox v-for="rep in availableReplyCols" :key="rep.value" :value="rep.value">{{ `${rep.companyName} --- ${rep.submittedOnString}${rep.isLatest ? ' (LATEST)' : ''}`}}</b-form-checkbox> -->
                        </b-form-checkbox-group>  <!-- do not use v-model -- handle change through handler so you know what changed -->
                    </b-collapse>
                </div>
                <!-- <hr v-if="hasAnalyticsCols"> -->
                <div v-if="hasAnalyticsCols" class="toggle-group">
                    <div class="toggle-heading">
                        <b-button 
                            v-b-toggle="'toggle-group-collapse-analysis-cols'"
                            variant="zone-light"
                            class="toggle-group-collapse-button"
                        >
                            <span class="collapse-button-text">Analysis Columns</span>
                            <div class="collapse-button-icon">
                                <b-icon icon="chevron-down" class="when-closed"></b-icon>
                                <b-icon icon="chevron-up" class="when-open"></b-icon>
                            </div>
                        </b-button>
                    </div>
                    <b-collapse id="toggle-group-collapse-analysis-cols" visible class="toggle-group-collapse">
                        <div class="show-hide-links">
                            <b-link href="#" @click="showAllAnalysisCols" class="show-hide-toggle-link">Show All</b-link>
                            <b-link href="#" :disabled="!visibleAnalysisColIds.length" @click="hideAllAnalysisCols" class="show-hide-toggle-link">Hide All</b-link>
                        </div>
                        <b-form-checkbox-group
                            :checked="visibleAnalysisColIds"
                            :options="availableAnalysisCols"
                            @change="handleVisibleAnalysisColsChange"
                            class="compare-grid-toggle-checkboxes"
                            stacked
                        ></b-form-checkbox-group>  <!-- do not use v-model -- handle change through handler so you know what changed -->
                    </b-collapse>
                </div>
            </div>
            <div :style="wrapperStyleObj" class="flex-fill company-todo-compare-grid-wrapper">  <!-- GRID WRAPPER -->
                <ag-grid-vue
                    ref="theGrid"
                    :style="gridStyleObj"
                    class="ag-theme-supplios company-todo-compare-grid w-100"
                    :gridOptions="gridOptions"
                    :context="gridContext"
                    :sideBar="sideBar"
                    :defaultColDef="defaultColDef"
                    :columnTypes="columnTypes"
                    :columnDefs="columnDefs"
                    :rowData="rowData"
                    :getRowClass="getRowClass"
                    :rowClassRules="rowClassRules"
                    :autoGroupColumnDef="autoGroupColumnDef"
                    :overlayLoadingTemplate="overlayLoadingTemplate"
                    :overlayNoRowsTemplate="overlayNoRowsTemplate"
                    :domLayout="domLayout"
                    :suppressRowHoverHighlight="suppressRowHoverHighlight"
                    :enableRangeSelection="enableRangeSelection"
                    :isGroupOpenByDefault="isGroupOpenByDefault"
                    :excelStyles="excelStyles"
                    @column-resized="updateRowHeights"
                    @new-columns-loaded="sizeColumnsToFit"
                    @column-visible="handleColumnVisible"
                    @filter-changed="handleFilterChanged"
                    @cell-double-clicked="handleCellDoubleClicked"
                    @grid-ready="onGridReady"
                ></ag-grid-vue>
            </div>
        </div>
        
        </div>
        <!-- <pre>{{ rawRespData }}</pre> -->

    </div>
</template>

<script>
import { errorHandling, currentUserInfoMixin } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service';
import { AgGridVue } from 'ag-grid-vue';
import { itemTypes } from '../../js/formium-helpers';  // canonical list of formium fields for frontend -- ARRAY
import { 
    QsItemForReply, 
    QsItemVariantForReply, 
    //QuoteSheetReplyBid 
} from '../quotesheets/quotesheet-reply-helpers';
import { 
    genericBidPriceFormatter,
    CompareGridBidPriceCellRenderer,
} from '../quotesheets/quote-sheet-vendor-cols.js';
import { 
    grandTotalVariantId,
    CompareGridRow,
    QuoteSheetRowChartHeaderRenderer,
    QuoteSheetRowChartCellRenderer,
    FormiumFormCompareGridRow,
    FormiumValueCellRenderer,
    DocRequestCompareGridRow,
    docRequestRows,
    docRequestValueCellRendererMap,
    VendorReplyColGroupHeader,
    SingleReplyHeaderRenderer,
    SmartFormCompareGridRow,
    SmartFormValueCellRenderer,
    SmartFormItemCellRenderer,
    AnalysisColGroupHeader,
} from './company-todo-compare-grid-helpers';
import { DateTime } from 'luxon';
import { QuoteSheet } from '../quotesheets/quote-sheet-common-helpers';
import { 
    FormatDateHelper,
    toNumberOrNull,
    hasValueOrZero,
} from '../../js/filters-helpers.js';
import {
    agNumberFormatter,
    agDateFormatter,
} from '../../js/ag-grid-helpers';
import { 
    DownloadLinkRenderer,
    FileDownloadBadgeRenderer,
    MultipleFileDownloadButtonRenderer,
} from '../../js/ag-grid-components';
import {
    SimplePlaceholderRenderer,
    SavingOverlayComponent,
    GenericBooleanRenderer,
    ValidationStatusRenderer,
    //validSnippet,
    //invalidSnippet,
    DisabledVendorInputRenderer,
    NoBidInputRenderer,
    SimpleDisabledInputRenderer,
    PriceCellRenderer,
    BootstrapVueDatePickerEditor,
    //VueDatePickerEditor,
    VueDateButtonRenderer,
    LeadTimeEditor,
    GenericCheckboxCellRenderer,
    VendorResponseHeaderRenderer,
    DynamicPaddingRenderer,
} from '../quotesheets/quote-sheet-components';
import { formatSmartFormValue } from '../smartforms/smartforms-helpers';
import { formatMoney } from '@/js/utils/moneyUtils';
import { sanitizeFilename } from '@/js/utils/stringUtils';
// LODASH IMPORTS
import cloneDeep from 'lodash/cloneDeep';
//import sum from 'lodash/sum';
import max from 'lodash/max';
import orderBy from 'lodash/orderBy';
import { v4 as uuidv4 } from 'uuid';

const variantGetter = function(params) {
    // value getter for ag-grid cells to pull data from nested 'variant' object
    let fieldKey = params.colDef.field;
    return params.data ? params.data.variant[fieldKey] : '';
}

const quoteSheetValueGetter = function(params) {
    // valueGetter for the individual columns in each reply we're comparing in the grid
    // get Reply.id from column.parent groupId, and get field from the colDef.field
    let fieldKey = params.colDef.field;
    let replyId = params.colDef.replyId;  // params.column.parent.groupId;
    return params.data?.bids?.[replyId] ? params.data.bids[replyId][fieldKey] : '';
}

/* MOVED TO quote-sheet-vendor-cols where you define other things like this
const compareGridBidPriceFormatter = function(params) {
    let replyId = params.column.parent.groupId;
    let price_amount = params.data ? params.data.bids[replyId]['price'] : null;
    let price_currency = params.data ? params.data.bids[replyId]['price_currency'] : '';
    return FormatCurrencyHelper(price_amount, price_currency);
} */

const isFirstColInGroup = function(params) {
    // use this in cellClassRules -- returns Boolean, true if this cell is first col in its group
    const thisCol = params.columnApi.getColumn(params.colDef.colId);
    //this.$devlog('Here is thisCol from first-cell-in-group cellClassRules');
    //this.$devlog(thisCol);
    const colBefore = params.columnApi.getDisplayedColBefore(thisCol);
    if (!thisCol || !colBefore) {
        return false;
    }
    return thisCol.parent?.groupId !== colBefore.parent?.groupId;  // if they're not the same group, then this is first in group
}

// FORMIUM FORM THINGS

const formiumItemSlugFormatterMap = new Map(itemTypes.map(fit => [fit.value, fit.valueStringFormatter]));  // Map() of formium_item_slug: valueStringFormatter function (pass in the value)

const formiumFormValueGetter = function(params) {
    // valueGetter for the individual columns in each reply we're comparing in the grid for FORMIUM FORMS
    // get Reply.id from column.parent groupId, and get field from the colDef.field
    //let fieldKey = params.colDef.field;
    let replyId = params.colDef.colId;  // params.column.parent.groupId;  
    //return params.data ? params.data.replies[replyId] : '';  // RETURN THIS IF WE WILL ALSO USE valueFormatter
    // now format the value... combining valueGetter and valueFormatter so Excel exports are better... and since we won't be sorting/filtering on raw values, so converting things to strings is OK
    const valueGetterValue = params.data ? params.data.replies[replyId] : '';
    const formiumItemSlug = params.data.formium_item.field_type_slug;
    const formatterFunction = formiumItemSlugFormatterMap.get(formiumItemSlug);  // a function that takes one arg... the raw value to format
    // add in some checking for null/undefined???
    return formatterFunction(valueGetterValue);
}

// see notes above about combining valueGetter and valueFormatter
/* const formiumFormValueFormatter = function(params) {
    // format the value of the formium_data -- must be different for each row, depending on formium_item_slug
    // params includes:  value, data, node, colDef, column, api, columnApi, context
    // OR... you can add this to each data instance when you make those... maybe better...
    const formiumItemSlug = params.data.formium_item.field_type_slug;
    const formatterFunction = formiumItemSlugFormatterMap.get(formiumItemSlug);  // a function that takes one arg... the raw value to format
    // add in some checking for null/undefined???
    return formatterFunction(params.value);
} */

// SMARTFORM THINGS

const smartFormValueGetter = function(params) {
    // valueGetter for the individual columns in each reply we're comparing in the grid for SmartForms
    // this relies on having the values for each reply in the rowData -- which you do when you build the rows for SmartForms from API data
    let replyId = params.colDef.colId;  // params.column.parent.groupId;  
    // now format the value... combining valueGetter and valueFormatter so Excel exports are better... and since we won't be sorting/filtering on raw values, so converting things to strings is OK
    const valueGetterValue = params.data ? params.data.replies[replyId] : '';
    return valueGetterValue;
}

const smartFormValueFormatter = function(params) {
    // this does the FORMATTING of the value returned from smartFormValueGetter 
    const rawValue = params.value;
    const smartFormFieldObj = params.data?.smartform_field;
    return !!rawValue && !!smartFormFieldObj ? formatSmartFormValue(rawValue, smartFormFieldObj) : '';
}

// DOCREQUEST THINGS

//const docRequestValueFormatterMap = new Map(docRequestRows.map(drr => [drr.dataKey, drr.valueStringFormatter]));  // Map() of docRequestRow.dataKey: valueFormatter function (pass in the value)

const docRequestValueGetter = function(params) {
    // valueGetter for the individual columns for each docrequest reply
    // uses method on row data instance
    let replyId = params.colDef.colId;  // params.column.parent.groupId;  
    const value = params.data ? params.data.getReplyData(replyId) : '';
    return value;  // maybe add a formatter later
}

const ANALYSIS_COL_KEYS = {  // for easy consistent reference
    min: 'minBidPrice',
    mean: 'meanBidPrice',
    max: 'maxBidPrice',
}

export default {
    name: 'CompanyTodoCompareGrid',
    components: {
        AgGridVue,
    },
    mixins: [
        errorHandling,
        currentUserInfoMixin,  // use $currentUserInfo
    ],
    props: {
        rctdId: {  // should be required for now, until you add other 'use-case-specific' CompanyToDos
            type: [String, Number],
            required: false,
        },
        onlyLatest: {  // only show latest for each vendor, force it
            type: Boolean,
            default: false,
        },
        responseIds: {
            // IF SET, we limit showing ONLY these response IDs -- we still fetch all, but only show these
            type: Array,
            required: false,
        },
        /* quoteSheetId: {  // add other use-case-specific CompanyToDo classes... when you need them - then in mounted, etc. you can set things accordingly
            type: [String, Number],
            required: false, 
        }, */
        // ADD PROPS FOR:  
        // only showing latest, 
        // limiting to certain vendor/RfxResponse IDs  (can still fetch, but just show those)
        // hiding certain things (resopnse details, analysis cols)
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            gridCanMount: false,  // NEW MAY 11 2022 - set true when all is prepped to actually start showing grid
            // AG-GRID stuff
            gridOptions: null, // big config object for ag-grid
            gridContext: {},  // MAY 14 2022 - updated to start with {} instead of null, then add to it as we go -- (context) set in beforeMount, separate from gridOptions, then update if/when needed
            sideBar: null,  // set in beforeMount, configures sidebar panels / column toolbar, etc.
            defaultColDef: null,  // set all this stuff in some hook like beforeMount
            columnTypes: null,
            gridApi: null,  // set this in mounted, easy way to manipulate grid on the fly
            gridColumnApi: null,  // set this in mounted, easy way to manipulate grid on the fly
            //defaultGroupSortComparator: null,  // used to set ORDERING of groups - set in beforeMount
            columnDefs: null,
            rowData: [], // set these in beforeMount() or somewhere like that --- DO NOT USE V-MODEL -- it kinda works, but causes funky stuff when updating the grid (like collapsing all groups, etc.) - let grid manage its own data
            getRowClass: null,  // callback to add classes to all rows, we'll add the todo category name to ALL rows using this (have to use function or else blank value gets set before data is loaded from API)
            rowClassRules: null,  
            overlayLoadingTemplate: null,  // set in beforeMount
            overlayNoRowsTemplate: null,  // set in beforeMount
            defaultGroupHeaderHeight: 70, // used in gridOptions, and also in my own methods for adjusting groupHeaderHeight
            domLayout: 'normal',  // change between 'normal' (expands to size of parent element) or 'autoHeight' (renders all rows) depending on category
            wrapperStyleObj: {height: '100%'},  // change this together with domLayout -- change both in this.setGridLayout() -- this should be changed instead of gridStyleObj (but have data property for that too)
            gridStyleObj: {},  // change this together with domLayout? -- change both in this.setGridLayout()
            autoGroupColumnDef: null,  // ***************
            enableRangeSelection: true,  // we'll change this based on category 
            isGroupOpenByDefault: null,  // a callback... set it if/when needed (for smartforms for now)
            excelStyles: [],  // array of Excel styles for export -- set in beforeMount
            // FLAGS & GENERAL THINGS
            loading: true, // loading initial data - start with true because you're using transition
            category: '',  // get from API, will be 'docrequest', 'quotesheet', 'formium_form', 'smartform'
            title: '',  // explicitly set this when we are processing data from API
            // QUOTESHEETS
            quoteSheetData: new QuoteSheet({}),  // we'll make new QuoteSheet() with API data and stash here
            hasMultipleVariants: false,  // we'll toggle true if we find any items with multiple variants
            quoteSheetVisibleVendorColIds: [],  // array of col keys for vendor cols that are VISIBLE (v-model with checkboxes) -- after updating this, call methods to show/hide cols in the grid for each reply
            quoteSheetAvailableVendorCols: [],  // all possible options OBJECTS for quoteSheetVisibleVendorColIds -- full objects, used as list of options for checkboxes
            quoteSheetVisibleItemColIds: [],  // array of col keys for item cols that are VISIBLE (v-model with checkboxes)
            quoteSheetAvailableItemCols: [],  // all possible options OBJECTS for quoteSheetVisibleItemColIds -- full objects, used as list of options for checkboxes
            visibleReplyIds: [],  // array of reply IDs that are currently visible in the grid -- used to show/hide cols for each reply using checkboxes
            availableReplyCols: [],  // array objects {replyId, replyLabel} for each reply in the grid -- used to show/hide cols for each reply using checkboxes
            availableReplyColsByCompany: [],  // array of objects {company_id, company_name, replies: [{}}} -- nested by company -- used in checkboxes (maybe)
            // colToggleCollapseVisible: {  // NOT USED YET controls the visibility of the collapse sections for each group of cols
            //     'item-details': true,
            //     'vendor-data': true,
            //     'replies': true,
            //     'analysis-cols': true,
            // },
            replyToggleStore: {},  // NOT USING YET???  object with keys for each replyId, and value of object with  {isVisible, ...other stuff about the company and reply} to use in checkboxes
            // OLD showMinMaxHighlights: true,  // can toggle this on/off to show highlights for min/max price bids
            companyColGroupIdSet: new Set(),  // Set of colGroup IDs for all the replies in the grid, used in this.gridColumnApi. methods - set once when building the grid - then make array using Array.from(mySet)
            minReplyColGroupWidth: 150,  // number of pixels for minimum column group width for each reply... auto sizing of cols never takes into account column groups (per docs) so we have to do it manually
            // FORMIUM FORMS
            formiumFormData: {},  // stash formium form data here
            // DOCREQUEST DATA
            docRequestData: {},  // stash doc request data here
            // SMARTFORMS
            smartFormData: {}, 
            smartFormDefaultExpandIds: [],  // array of row IDs to START expanded -- after first render, this is not used
            isDownloadingSmartFormReplies: false,  // disable button while downloading full responses .xlsx
            // PRICE ANALYSIS - now shared between QuoteSheets and SmartForms
            showPriceAnalysis: true,  // show the priceAnalysis columns?  we have a method that toggles this
            priceAnalysisColKeys: [ANALYSIS_COL_KEYS.min, ANALYSIS_COL_KEYS.mean, ANALYSIS_COL_KEYS.max],
            visibleAnalysisColIds: [],  // array of col keys for analysis cols that are VISIBLE (v-model with checkboxes) -- after updating this, call methods to show/hide cols in the grid for each reply
            availableAnalysisCols: [],  // all possible options OBJECTS for visibleAnalysisColIds -- full objects, used as list of options for checkboxes - build when you build analysis cols for each category
            // STASHED DATA FROM API
            rawRespData: null,  // full response data from API
            rawReplies: null,  // raw replies array from API - we use this in computed to know if we have replies
            colIdReplyMap: {},  // MAY 14 2022 - new thing we build up for easily getting data about a reply from a colId
            replyIdToColIds: {},  // June 14 2022 - array of colIds (values) for each replyId (key) -- for QuoteSheets, there are multiple cols per reply, but for others, replyCol is NOT a group col, so they will be 1:1.... but keeping same format of Array of colIds - used to show/hide cols for latest/all replies
            companyReplyMap: {},  // June 13 2022 - object keyed by company_id, with object of company data and all replies nested inside 'replies' key ('replies' is an object, keyed by replyId)
        }
    },
    computed: {
        isQuoteSheet: function() {
            return this.category === 'quotesheet';
        },
        isFormiumForm: function() {
            return this.category === 'formium_form';
        },
        isDocRequest: function() {
            return this.category === 'docrequest';
        },
        isSmartForm: function() {
            return this.category === 'smartform';
        },
        suppressRowHoverHighlight: function() { // true = NO HIGHLIGHT (suppress)
            // bound to :suppressRowHoverHighlight in grid component
            const hoverOnCategories = ['quotesheet', 'formium_form'];
            //const hoverOffCategories = ['docrequest'];
            return !hoverOnCategories.includes(this.category);
        },
        hasReplies: function() {
            return this.rawReplies && Array.isArray(this.rawReplies) && !!this.rawReplies.length;
        },
        hasMultipleRepliesPerCompany() {
            // do ANY of the companies have multiple replies per company in the complete list of replies?
            // used to show buttons for show all/latest for all companies
            const companyIds = this.rawReplies.map(rep => rep.company_id);
            const companyIdsUnique = [...new Set(companyIds)];
            return companyIds.length != companyIdsUnique.length;
        },
        hasAnalyticsCols() {
            // checks if any of the analytics cols are in the grid (visible or not) 
            // based on the category of things we're showing (quotesheets, smartforms)
            const allColIds = this.gridColumnApi?.getAllColumns().map(c => c.colId) ?? [];
            return this.priceAnalysisColKeys.some(ac => allColIds.includes(ac));
        },
        replyToggleNestedArray() {
            // array of objects from replyToggleStore, nested by company_id
            return [];  // TODO
        },
    },
    beforeMount: function() {
        // ag-grid setup
        this.gridOptions = {
            // moved context to separate object with direct binding to grid
            components: {
                simpleDisabledInputRenderer: SimpleDisabledInputRenderer,  // USE THIS -- not a vue component, but simple and works great
                noBidInputRenderer: NoBidInputRenderer,  // use this for cells when the vendor selects 'No Bid' in the row
                priceCellRenderer: PriceCellRenderer,  // for rendering placeholder for price
                compareGridBidPriceCellRenderer: CompareGridBidPriceCellRenderer,  // specifically for showing prices internally - referenced in things we import, not necessarily in this file
                simplePlaceholderRenderer: SimplePlaceholderRenderer,  // must have cellRendererParams: { placeholder: 'Placeholder Text' }
            },
            frameworkComponents: {
                // use componentName: ComponentName format (note small letter, big letter)
                // then use: colDef: {cellRenderer: 'componentName'}  // small letter, string name
                savingOverlayComponent: SavingOverlayComponent,
                bootstrapVueDatePickerEditor: BootstrapVueDatePickerEditor,
                //vueDatePickerEditor: VueDatePickerEditor,
                vueDateButtonRenderer: VueDateButtonRenderer,
                leadTimeEditor: LeadTimeEditor,
                genericCheckboxCellRenderer: GenericCheckboxCellRenderer,
                disabledVendorInputRenderer: DisabledVendorInputRenderer,
                genericBooleanRenderer: GenericBooleanRenderer,
                vendorResponseHeaderRenderer: VendorResponseHeaderRenderer,
                dynamicPaddingRenderer: DynamicPaddingRenderer,
                validationStatusRenderer: ValidationStatusRenderer,  // very simple way of showing OK/Invalid 
                vendorReplyColGroupHeader: VendorReplyColGroupHeader,  
                singleReplyHeaderRenderer: SingleReplyHeaderRenderer,
                downloadLinkRenderer: DownloadLinkRenderer, 
                fileDownloadBadgeRenderer: FileDownloadBadgeRenderer,
                multipleFileDownloadButtonRenderer: MultipleFileDownloadButtonRenderer,
                formiumValueCellRenderer: FormiumValueCellRenderer,
                smartFormValueCellRenderer: SmartFormValueCellRenderer,
                smartFormItemCellRenderer: SmartFormItemCellRenderer,
                analysisColGroupHeader: AnalysisColGroupHeader,
                quoteSheetRowChartHeaderRenderer: QuoteSheetRowChartHeaderRenderer,
                quoteSheetRowChartCellRenderer: QuoteSheetRowChartCellRenderer,
            },
            tooltipShowDelay: 500,  // in ms
            enterMovesDown: true,
            enterMovesDownAfterEdit: true,
            //rowSelection: "multiple",
            // enableRangeSelection: true,  // update this once we know category
            enableFillHandle: false,
            //undoRedoCellEditing: true,  // seems to not work on tree data since it does auto-grouping
            //rowDragManaged: true,  // default is false
            animateRows: true,  // false is default, better performance
            //suppressRowTransform: true,  // needed for row spanning, but hurts performance
            groupHeaderHeight: this.defaultGroupHeaderHeight,  // we are referencing this below when updating row heights!
            headerHeight: 50,
            applyColumnDefOrder: true,  // this honors the column order in colDefs, even when updating them after initial load
            groupSuppressAutoColumn: true, // ************ // moved to top-level, in data, so it can be changed in some cases
            //groupMultiAutoColumn: true,
            groupHideOpenParents: true,   // groupRemoveSingleChildren and groupHideOpenParents cannot be used together!
            groupDefaultExpanded: -1,  // number of levels to expand by default... -1 means all, always - change in beforeGridMount if needed
            // HANDLERS & CALLBACKS
            getRowNodeId: function(data) {
                return data ? data.id : '';  // should return strings
            },  // use this to have grid use your own defined node IDs... or let it use its own.  should return strings.
            // DOES NOT WORK DECLARING IT BEFORE YOU KNOW WHAT CATEGORY IT IS!  rowHeight: this.isDocRequest ? 60 : null,  // set this based on what category of todo we're working with -- will this still let us do autoRowHeight?
            //rowHeight: 32,  // setting this, even though we have autoHeight on - or set in grid css settings instead?
        };
        this.gridContext = {  // we will add more later after loading data from API
            componentParent: this,  // then child 'framework components' inside here can access this 'parent' component via this.params.context.componentParent
        //     currency: this.quoteSheetData.currency,  // this sets initial value, but its not reactive... have to update explicitly on changes
        //     qsItemMap: new Map(),  // instantiate this, fill it up when you get data from API, and when adding things to grid
        //     linkedProductMap: new Map(),  // instantiate this, fill it up when you get data from API, and when adding things with linked products
        };
        this.defaultColDef = {
            resizable: true,
            editable: false,
            //suppressMovable: true,
            suppressMenu: true,  // hides the menu for each col... set false if you want filters, or use inline/floating? filters
            wrapText: true, 
            autoHeight: true,  // not allowed if doing row spanning!
            singleClickEdit: false,
            enableCellChangeFlash: true,
        };
        this.autoGroupColumnDef = {
            minWidth: 100,
            maxWidth: 200,
            cellStyle: {
                'font-weight': 'bold',
            },
            headerClass: ['pl-3'],
            cellRendererParams: {
                suppressCount: true,
            },
            //cellClass: ['pl-3', 'cell-muted'],
            /* filterValueGetter: (params) => {
                var colGettingGrouped = params.colDef.showRowGroup;
                var valueForOtherCol = params.api.getValue(
                colGettingGrouped,
                params.node
                );
                return valueForOtherCol;
            }, */
        };
        this.overlayLoadingTemplate =
            '<span class="ag-overlay-loading-center py-3 px-4 bg-white rounded">Loading supplier responses...</span>';
        this.overlayNoRowsTemplate =
            '<span class="py-3 px-4 bg-danger-50 rounded">No data in supplier responses</span>';  // this will only show if you're showing the grid and no rows... but if you have no replies at all, you will hide grid
        this.sideBar = {
            toolPanels: [
                // NOT SHOWING COLUMNS TOOL PANEL ANY LONGER (Sept 7 2024 - replaced with custom column checkbox toggles, and otherwise they conflict)
                // {
                //     id: 'columns',
                //     labelDefault: 'Columns',
                //     labelKey: 'columns',
                //     iconKey: 'columns',
                //     toolPanel: 'agColumnsToolPanel',
                //     toolPanelParams: {
                //         suppressRowGroups: true,
                //         suppressValues: true,
                //         suppressPivots: true,
                //         suppressPivotMode: true,
                //         suppressColumnFilter: true,
                //         suppressColumnSelectAll: true,
                //         suppressColumnExpandAll: true,
                //         contractColumnSelection: true,  // if true, then groups start contracted instead of expanded - maybe make this dynamic based on category?
                //     },
                // },
                {
                    id: 'filters',
                    labelDefault: 'Filter Rows',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel',
                },
            ],
            defaultToolPanel: null,  // use 'columns' or 'filters' or null to display closed by default
        };
        this.getRowClass = () => this.category;  // just add the category name - can override this based on todo type if needed
        this.rowClassRules = {
            'item-firstrow': (params) => {
                return params.node.firstChild;  // when using row grouping with hidden open parents, this will be first row if there are multiple variants, or just one variant
            },
            'item-midrow': (params) => {
                return !params.node.firstChild && !params.node.lastChild;
            },
            'item-lastrow': (params) => {
                return params.node.lastChild;  
            },
            'variant-indicator-row': (params) => {
                return params.node.parent && (params.node.parent.allChildrenCount > 1);
            },
            'group-single-variant': (params) => {
                return params.node.parent && (params.node.parent.allChildrenCount === 1);
            },
            'is-reply-input': (params) => {
                return params.data?.smartform_field?.is_reply_input || (!!params.data?.smartform_field?.custom_classes && Array.isArray(params.data.smartform_field.custom_classes) && params.data.smartform_field.custom_classes.includes('external'));  // won't have is_reply_input anymore... pass classes from backend instead
            },
            'is-calculated': (params) => {
                return params.data?.smartform_field?.is_calculated;
            },
            'smartform-show-analysis': (params) => {
                return params.data?.enableAnalysisForRow;
            },
            'grand-total-row': (params) => params.data?.isGrandTotalRow,
        };
        this.excelStyles = [  // could also set this in excelExportParams in this.exportExcel
            {
                id: 'is-min-price',  // make sure this matches the cellClassRules key
                interior: {
                    color: '#e2f3ee', // '#b5e6b5',
                    pattern: 'Solid',
                },
            },
            {
                id: 'is-max-price',  // make sure this matches the cellClassRules key
                interior: {
                    color: '#fdeaea', // danger-50
                    pattern: 'Solid',
                },
            },
        ];  // can set excel styles for export, re-using cellClassRules
        this.columnTypes = {
            'firstChildVisible': {  // use in cols where you only want first child to be visible... use with groupHideOpenParent row grouping
                cellClassRules: {
                    //'d-none': (params) => {return params.node.childIndex !== 0},
                    'd-none': (params) => {return params.node.firstChild === false},
                },
            },
            'priceCol': {
                cellClassRules: {
                    'is-min-price': params => params.data && params.colDef.isLatest && (params.value === params.data[ANALYSIS_COL_KEYS.min]) && params.data.hasMultiplePricesForAnalysis,
                    'is-max-price': params => params.data && params.colDef.isLatest && (params.value === params.data.maxBidPrice) && params.data.hasMultiplePricesForAnalysis,
                    // NOTE - you SHOULD compare by value, not just ID, in case multiple are tied for min/max
                    // but add these classes if the reply isLatest from the company
                    //'is-min-price': params => params.data && (params.colDef.replyId == params.data.minReplyId) && params.data.hasMultiplePricesForAnalysis,
                    //'is-max-price': params => params.data && (params.colDef.replyId == params.data.maxReplyId) && params.data.hasMultiplePricesForAnalysis,
                },
                // March 3 2022 - not putting for valueFormatter here
                // instead, put it in quote-sheet-vendor-cols -- that's where you define all other formatters for similar things
                // and you are currently only formatting prices in quotesheets anyways
                // just be careful since the valueFormatter for this has to get things from places, kinda like a getter...
                // valueFormatter: compareGridBidPriceFormatter,  // converts from stored value to displayed value
            },
            'priceAnalysisCol': {
                minWidth: 80,
                maxWidth: 150,
                headerClass: ['column-align-center', 'analysis-col'], // I think center looks better for headers
                // MOVED TO EACH colDef cellClass: ['column-align-right', 'analysis-col', 'cell-muted'],
                cellClassRules: {
                    'first-col-in-group': params => isFirstColInGroup(params),
                },
                valueFormatter: (params) => {
                    const currencyCode = params.data ? params.data.priceCurrency : '';  // if currency mismatch between bids, will return empty string - March 1 2022 -- also, if all bids are NOBID (or otherwise no valid prices in this row) will also be empty string
                    // OLD - does not support extra decimal digits: return FormatCurrencyHelper(params.value, currencyCode);  // this has a fallback to USD if currencyCode is falsey, but that should be OK here, since we won't have anything to display anyways
                    // NEW - March 3 2022
                    return genericBidPriceFormatter(params.value, currencyCode);  // make sense to show extra digits here??? see how it goes...
                },
            },
        };
    },
    mounted: function() {
        // ag-grid stuff
        //this.gridApi = this.gridOptions.api;
        //this.gridColumnApi = this.gridOptions.columnApi;     
        this.getDataFromApi();  // future: pass in the ID / type of use-case-specific CompanyToDo here so you call the right endpoint
        // TODO FUTURE - set local data for what to put in colGroup header action buttons, action options, etc... then pass that down to colGroup header renderer component params
        // do it once you know if/when you'll use this in other places
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        getDataFromApi: function(rfxResponseIds) {  // allow passing in only certain RfxResponse.ids 
            // NEW JULY 12 2022 - should we limit the rfx responses we include?  can pass as arg, or get from prop (prop wins)
            let onlyResponseIds;  // start undefined
            if (this.responseIds && Array.isArray(this.responseIds)) {
                // empty array means no responses... might want it - not sure backend will honor that... have to check how you implemented
                onlyResponseIds = [...this.responseIds];
            } else if (rfxResponseIds && Array.isArray(rfxResponseIds)) {
                onlyResponseIds = [...rfxResponseIds];
            }
            // SET QUERY PARAMS BASED ON SOME PROPS
            this.loading = true;
            //this.gridApi.showLoadingOverlay();
            let axiosConfig = {};
            axiosConfig.params = new URLSearchParams();
            if (onlyResponseIds && Array.isArray(onlyResponseIds)) {  // if empty array, you won't fetch any???
                onlyResponseIds.forEach(respId => axiosConfig.params.append('rfx_response_id', respId));
            }
            if (this.onlyLatest) {
                axiosConfig.params.append('latest', 'yes');
                // dont' even include it in query_params if not set
            }
            // ALLOW GETTING DATA FROM MULTIPLE ENDPOINTS... 
            // USE USE-CASE SPECIFIC ENDPOINTS SO YOU CAN CONTROL PERMS BETTER
            // BUT RESPONSE FORMAT SHOULD ALL BE THE SAME (use CompanyToDo view_functions.py for consistency)
            var apiCall;
            if (this.rctdId) {
                apiCall = suppliosApi.rfxCompanyToDo.getCompareGridData(this.rctdId, axiosConfig);  // started using axiosConfig July 12 2022 to limit responses if needed
            } else {  // REPLACE WITH else if (this.someOtherIdProp...)
                console.error(`Must specify rctd-id prop on ${this} for now`);
                return;
            }
                apiCall.then(response => {
                    this.loading = false;  // set this early to start showing grid in DOM
                    this.rawRespData = response.data; //  response.data will have keys 'quotesheet' and 'replies'
                    // STASH STUFF IN CONTEXT?
                    // SET DATA for ToDo - QUOTESHEET / FORMIUM FORM / DOCREQUEST -- used when building rows/cols
                    this.category = response.data.category;  // will be 'docrequest' 'quotesheet' 'formium_form', 'smartform'
                    this.quoteSheetData = response.data.quotesheet ? new QuoteSheet(response.data.quotesheet) : new QuoteSheet({});
                    this.formiumFormData = response.data.formium_form ? Object.assign({}, response.data.formium_form) : {};
                    this.docRequestData = response.data.docrequest ? Object.assign({}, response.data.docrequest) : {};
                    this.smartFormData = response.data.smartform ? Object.assign({}, response.data.smartform) : {};
                    this.rawReplies = response.data.replies;  // all types of replies will be here
                    const replies = cloneDeep(response.data.replies);
                    // SET ROWS - handle different categories of todos
                    let gridRows = [];  // default... then set based on this.category
                    if (this.category === 'quotesheet') {
                        // must add things to gridContext before building the rows and coldefs -- such as countries for country_of_origin - some of our cell getter/setter/parser/formatters depend on it
                        this.$set(this.gridContext, 'countryCodes', this.quoteSheetData.countryCodes);
                        this.$set(this.gridContext, 'countryNames', this.quoteSheetData.countryNames);
                        this.$set(this.gridContext, 'countryNamesByCode', this.quoteSheetData.countryNamesByCode);
                        this.$set(this.gridContext, 'countryCodesByName', this.quoteSheetData.countryCodesByName);
                        // now build the rows 
                        gridRows = this.buildQuoteSheetRows(response.data.quotesheet, replies);
                        this.title = this.quoteSheetData.title;
                    } else if (this.category === 'formium_form') {
                        gridRows = this.buildFormiumFormRows(this.formiumFormData, replies);
                        this.title = this.formiumFormData.title;
                    } else if (this.category === 'docrequest') {
                        gridRows = this.buildDocRequestRows(this.docRequestData, replies);
                        this.title = this.docRequestData.title;
                    } else if (this.category === 'smartform') {
                        gridRows = this.buildSmartFormRows(this.smartFormData, replies);
                        this.title = this.smartFormData.name;
                    }
                    this.rowData = gridRows;
                    // SET COLUMNS
                    this.columnDefs = this.buildColDefs(response.data.replies);
                    // don't reset col widths here... you have an event that will trigger it instead
                    /* this.$nextTick(() => {
                        this.afterGridDataLoaded();  // just a hook point to do things to the grid AFTER all the data is loaded in it - set column tool panel, etc.
                    }); */
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error, 'Error while getting Quote Sheet data')
                    return false;
                })
                .then(success => {
                    //this.loading = false;  // moved this up to first then, to prevent problems drawing grid and setting colWidths with grid hidden (since we hide grid until loading = false)
                    this.afterDataLoaded();
                    return success;
                })
        },
        afterDataLoaded() {
            // added May 11 2022 - we will fetch everything first, then prep things for grid, THEN start showing the grid
            // trying to load the grid in parallel with the data is a mess
            // we call this method AFTER data is loaded and configured for the grid
            //console.log('HELLO FROM afterDataLoaded');
            this.beforeGridMount();
            this.gridCanMount = true;
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;    
        },
        beforeGridMount() {
            // do things before we start mounting the grid - like overriding gridOptions, etc.
            // we will have data loaded from API at this point
            //console.log('HELLO FROM beforeGridMount');
            if (this.isSmartForm) {
                this.gridOptions.treeData = true;
                this.gridOptions.getDataPath = (data) => {
                    return data.nested_path;  // needed for treeData = true
                }; 
                this.gridOptions.groupSuppressAutoColumn = false;  // normally true
                //-----this.gridOptions.groupMultiAutoColumn = true;
                //-----this.gridOptions.groupHideOpenParents = false;  // true,   // groupRemoveSingleChildren and groupHideOpenParents cannot be used together!
                this.gridOptions.groupDefaultExpanded = null;  // 0 means not all open, not all closed - using callback isGroupOpenByDefault instead
                this.gridOptions.groupHideOpenParents = false;   // groupRemoveSingleChildren and groupHideOpenParents cannot be used together!
                this.isGroupOpenByDefault = (params) => {
                    // set expand: true on the group rows you make in backend / specify in 'compare_grid'
                    // IMPORTANT - the rows are not fully built yet... so you don't have any row data to use
                    // instead, as YOU build the rows, you'll track which ones should be expanded (by their 'id', which ag-grid uses here as params.key)
                    // then check that and expand those
                    return this.smartFormDefaultExpandIds.includes(params.key);
                };
                // override normal getRowClass to add extra 'custom_classes' for smartform fields
                this.getRowClass = (params) => {
                    // must add the default one too - just the name of category 
                    const cssClasses = [this.category];
                    const fromData = params.data?.custom_classes;
                    if (fromData && Array.isArray(fromData)) {
                        cssClasses.push(...fromData);
                    }
                    return cssClasses;
                };
                this.autoGroupColumnDef = {  // we have a default defined (in top level data), but override here because of treeData
                    headerName: 'Item',
                    //field: 'smartform_data',
                    suppressColumnsToolPanel: false,  // hide from cols tool panel
                    chartDataType: 'category',
                    pinned: false,
                    filter: true,
                    //rowGroup: true,
                    //type: ['noEditCol'],
                    minWidth: 200,
                    maxWidth: 350,
                    cellStyle: {
                        'font-weight': 'bold',
                    },
                    headerClass: ['pl-3'],
                    cellClass: ['pl-3', 'cell-muted', 'smartform-item'],
                    //cellRenderer: 'smartFormItemCellRenderer',
                    cellRendererParams: {
                        innerRenderer: 'smartFormItemCellRenderer',  // use this only as innerRenderer so normal group renderer handles expand/collapse, etc.
                        suppressCount: true,  // don't show count per group - meaningless
                    },
                    valueGetter: (params) => {
                        //console.log('params from valueGetter', params);
                        return params.data ? params.data.label : params.node.groupData[params.column.colId];
                    },  // the extra 'filled' rows added by the grid for treeData groups will not have params.data - for those, just pass on the raw value, which should be the hierarchy array of strings
                };
            }
        },
        onGridReady(event) {
            // do things now that grid is ready - this is called when we get gridReady event from grid
            console.log('HELLO FROM this.onGridReady'); 
            console.log(event);
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;     
            this.afterGridAndDataReady();
        },
        afterGridAndDataReady: function() {
            // CONFIGURE / SET things in the grid based on what category we're working with
            // NO LONGER USING columnsToolPanel - replaced with custom column checkbox toggles - but you could do similar things later
            // const columnsToolPanel = this.gridApi.getToolPanelInstance('columns'); 
            //const companyColGroupIds = Array.from(this.companyColGroupIdSet);  // ARRAY of column groupId for the COMPANY col groups
            //const companyColGroupIdsWithMultipleReplies = Object.values(this.companyReplyMap).filter(comp => comp.hasMultipleReplies).map(comp => comp.id);
            //console.log('companyColGroupIdsWithMultipleReplies', companyColGroupIdsWithMultipleReplies);
            if (this.isQuoteSheet) {  // we set default to not expand colGroups in columns tool panel... so we expand them selectively here
                //const standardColGroups = ['quotesheet_item_details', 'quotesheet_quantity', 'price_analysis_columns'];  // quotesheets have col groups on the left-side cols too
                //columnsToolPanel?.expandColumnGroups([...standardColGroups, ...companyColGroupIdsWithMultipleReplies]);  // pass in ARRAY of colGroupIds
                this.enableRangeSelection = true;  // ALLOW range selection for copy/paste/export
                this.setGridLayout('normal');  // set to 'normal' to expand to size of parent... because we may have lots of rows -- will look worse with empty rows, but we can't allow autoHeight for this -- too risky if lots of rows
            } else if (this.isDocRequest) {
                // do docRequest things
                this.enableRangeSelection = false;  // TURN OFF range selection for copy/paste/export (annoying and no value add for docrequests)
                this.setGridLayout('autoHeight');  // will be very few rows, so autoHeight is OK - will look better
                //columnsToolPanel?.expandColumnGroups([...companyColGroupIdsWithMultipleReplies]);  // expand companies that have multiple replies
            } else if (this.isFormiumForm) {
                // do formium form things
                this.enableRangeSelection = true;  // ALLOW range selection for copy/paste/export
                this.setGridLayout('normal');
                //columnsToolPanel?.expandColumnGroups([...companyColGroupIdsWithMultipleReplies]);  // expand companies that have multiple replies
            } else if (this.isSmartForm) {
                this.enableRangeSelection = true;
                this.setGridLayout('normal');
                //columnsToolPanel?.expandColumnGroups([...companyColGroupIdsWithMultipleReplies]);  // expand companies that have multiple replies
                // can add more customizations if needed...
            }
            // TODO - add more control for things you set via props (only latest, hide analytics, etc.)
        },
        setGridLayout: function(layout) {
            // toggle between domLayout = 'autoHeight' and no grid height / domLayout = 'normal' and height: 100%
            this.$devlog(`setting domLayout to ${layout}`);
            if (layout === 'autoHeight') {
                this.gridStyleObj = Object.assign({});  // no height
                this.gridApi.setDomLayout('autoHeight');
            } else if (layout === 'normal') {
                this.gridStyleObj = Object.assign({}, {height: '100%'});
                this.gridApi.setDomLayout('normal');
            }
            this.sizeColumnsToFit();
        },
        handleCellDoubleClicked(params) {
            // for debug, and testing out charting 
            console.log(params);  // just for debugging things
            //const { node } = params;  // can also get `rowIndex`, `data` - instance of SmartFormCompareGridRow
            /* if (this.isSmartForm) {
                // const { label, smartform_field } = data;  // data will be instance of SmartFormCompareGridRow
                // then you should inspect it to make sure its a chartable field, then get data, format using formatter, and pass to chart method
                this.makeSmartFormChart(node.id);
            } */  // no longer need this -- added a button
        },
        // TODO - make something like makeSmartFormChart for QuoteSheet rows!  and show current/target prices as lines
        makeQuoteSheetChart(rowId) {
            const rowNode = this.gridApi.getRowNode(rowId);
            if (!rowNode) return;
            console.log('rowNode we will chart', rowNode);
            const { rowIndex, data } = rowNode;
            const { isGrandTotalRow } = data;  // item is instance of QuoteSheetItem
            const fieldToUse = isGrandTotalRow ? 'subtotal' : 'price';  // we ONLY use subtotal for grand total row (maybe can change later, but if we want to use target_price and current_price, those only compare to 'price')
            const datapointLabel = isGrandTotalRow ? 'Grand Total' : 'Price';
            // can treat isGrandTotalRow specially....
            // const { item, variant } = data;  // data will be instance of CompareGridRow
            // const rowLabelParts = [item.itemName, item.partNumber, variant.description];
            // const label = rowLabelParts.filter(p => !!p).join(' - ');
            const label = data.rowLabel;  // getter on CompareGridRow
            // do you want to chart line item total?  or only price?  starting with only price...  then we can show target_price / current_price also
            const priceColIds = this.gridColumnApi.getAllColumns().filter(c => c.colDef.field === fieldToUse).map(c => c.colId);
            const getReplyNameFromColId = (colId) => {  // helper to use many places below
                const replyObj = this.colIdReplyMap[colId];
                const companyName = replyObj?.company?.name;
                return companyName + (replyObj.is_latest ? '' : ` (prev. submission - ${FormatDateHelper(replyObj.submitted_on)})`);
            };
            const quoteSheetCurrency = this.quoteSheetData.currency;
            const decimalPlacesForChartValues = 4;  // our formatter only shows extra decimal places if needed, so we should be good with this
            const qsPriceBaseCurrencyFormatter = (val) => {
                // formats ALL price values in the chart to the quotesheet base currency - maybe we have access to each row data???? and can format based on each cell instead?  
                // but this SHOULD be a safe assumption to format all the chart values to the same currency.... or else we should not be putting them on the same chart to begin with!
                let rawAmount = toNumberOrNull(val);
                // CLEVER, but not needed... we have something similar built-in to formatMoney: let decimalPlaces = hasValueOrZero(rawAmount) && rawAmount % 1 === 0 ? 0 : 4;  // if whole number, show 0 decimal places, otherwise 4
                return hasValueOrZero(rawAmount) ? formatMoney(rawAmount, quoteSheetCurrency, decimalPlacesForChartValues) : '';
            }
            // add target_price and current_price as extra datapoints in the series (or lines... but not sure how...)
            // TODO - style these differently...
            const refPriceColIdsAndLabels = {};
            if (fieldToUse == 'price') {
                if ( this.quoteSheetData.internalCols?.show_current_price === true) {
                    refPriceColIdsAndLabels['current_price'] = 'CURRENT PRICE';
                }
                if (this.quoteSheetData.internalCols?.show_target_price === true) {
                    refPriceColIdsAndLabels['target_price'] = 'TARGET PRICE';
                }
            }

            var params = {
                cellRange: {
                    rowStartIndex: rowIndex,
                    rowEndIndex: rowIndex,
                    columns: [...priceColIds, ...Object.keys(refPriceColIdsAndLabels)],
                },
                chartType: 'groupedColumn',
                chartThemeName: 'ag-default',
                chartThemeOverrides: {
                    column: {
                        axes: {
                            number: {
                                label: {
                                    formatter: function(params) {  // formats the labels on Y axix
                                        // console.log('axes number label params', params);
                                        return qsPriceBaseCurrencyFormatter(params.value);
                                    },
                                },
                            },
                            category: {
                                label: {
                                    //enabled: false,  // doesn't work...
                                    rotation: 0,
                                    formatter: function() {  // (params)  - formats labels on X axis - the SmartForm field label
                                        // WITH / WITHOUT treeData - value is different, since we're clicking from the group col in treeData mode
                                        // if using treeData, then value is the array of tree hierarchy, we just want the last one
                                        //console.log('axes category label params', params);
                                        //return `${params.value}`;
                                        return '';  // just don't use anything... you have legend anyways!
                                    }
                                }
                            }
                        },
                        series: {
                            // xKey: 'label',
                            // yKey: '',
                            // xName: 'vendor data',
                            // yName: 'vendor value',
                            label: {  // this is the label ON the column
                                formatter: (params) => {  // params is only the raw value { value }
                                    // console.log('series label params', params);  
                                    return qsPriceBaseCurrencyFormatter(params.value);
                                },
                                enabled: true,
                            },
                            // fillOpacity: 0.5,  // seems we can't make this a function....
                            tooltip: {
                                renderer: (params) => {
                                    // { datum, processedYValue, xKey, xName, xValue, yKey, yName, yValue } = params;  // yKey is the colId, yValue is the value you want
                                    const { processedYValue, yKey } = params;
                                    //console.log('tooltip params', params);
                                    if (refPriceColIdsAndLabels[yKey]) {
                                        // its a reference price - just show that
                                        const prettyName = refPriceColIdsAndLabels[yKey];
                                        return {  // return an object with { title, content } - supports HTML
                                            title: prettyName,
                                            content: qsPriceBaseCurrencyFormatter(processedYValue),
                                        };
                                    }
                                    return {  // return an object with { title, content } - supports HTML
                                        title: getReplyNameFromColId(yKey),
                                        content: qsPriceBaseCurrencyFormatter(processedYValue),
                                    };
                                },
                            },
                        },
                        title: {
                            enabled: true,
                            text: `${isGrandTotalRow ? this.title : datapointLabel}: ${label}`,  // if grand total, just show title for the whole quote sheet
                        },
                        legend: {
                            enabled: true,
                            item: {
                                label: {
                                    formatter: (params) => {
                                        // const { id, itemId, value } = params;  // itemId is the column ID - use that to get better label
                                        // console.log('params of legend formatter', params);
                                        const { itemId } = params;
                                        if (refPriceColIdsAndLabels[itemId]) {
                                            return refPriceColIdsAndLabels[itemId];
                                        }
                                        const replyObj = this.colIdReplyMap[itemId];
                                        return replyObj ? getReplyNameFromColId(itemId) : params.value;  // ?.company?.name ?? params.value;
                                    },
                                },
                            },
                        },
                    },
                },
                unlinkChart: false,  // unlink will make it not highlight the cells its charting
            };
            this.gridApi.createRangeChart(params);
        },
        makeSmartFormChart(rowId) {  // ONLY FOR SmartForms for now
            const rowNode = this.gridApi.getRowNode(rowId);
            if (!rowNode) return;
            //console.log('rowNode we will chart', rowNode);
            const { rowIndex, data } = rowNode;
            const { label, smartform_field } = data;  // group_label, replies, slug, smartform_field - replies is an object with { replyId: valueFromThatReply }
            const chartableColIds = this.gridColumnApi.getAllColumns().filter(c => c.colDef.chartDataType === 'series').map(c => c.colId);
            //console.log('chartableColIds', chartableColIds);
            const getReplyNameFromColId = (colId) => {  // helper to use many places below
                const replyObj = this.colIdReplyMap[colId];
                const companyName = replyObj?.company?.name;
                return companyName + (replyObj.is_latest ? '' : ` (prev. submission - ${FormatDateHelper(replyObj.submitted_on)})`);
            };
            const valueFormatter = (val) => {  // make a value formatter based on the field type of this row
                return !!val && !!smartform_field ? formatSmartFormValue(val, smartform_field) : '';
            }
            var params = {
                cellRange: {
                    rowStartIndex: rowIndex,
                    rowEndIndex: rowIndex,
                    columns: ['smartform_data', ...chartableColIds],
                },
                chartType: 'groupedColumn',
                chartThemeName: 'ag-default',
                chartThemeOverrides: {
                    column: {
                        axes: {
                            number: {
                                label: {
                                    formatter: function(params) {  // formats the labels on Y axix
                                        // console.log('axes number label params', params);
                                        return valueFormatter(params.value);
                                    },
                                },
                            },
                            category: {
                                label: {
                                    //enabled: false,  // doesn't work...
                                    rotation: 0,
                                    formatter: function() {  // (params)  - formats labels on X axis - the SmartForm field label
                                        // WITH / WITHOUT treeData - value is different, since we're clicking from the group col in treeData mode
                                        // if using treeData, then value is the array of tree hierarchy, we just want the last one
                                        //console.log('axes category label params', params);
                                        //return `${params.value}`;
                                        return '';  // just don't use anything... you have legend anyways!
                                    }
                                }
                            }
                        },
                        series: {
                            // xKey: 'label',
                            // yKey: '',
                            // xName: 'vendor data',
                            // yName: 'vendor value',
                            label: {  // this is the label ON the column
                                formatter: (params) => {  // params is only the raw value { value }
                                    //console.log('series label params', params);
                                    return valueFormatter(params.value);
                                },
                                enabled: false,
                            },
                            tooltip: {
                                renderer: (params) => {
                                    // { datum, processedYValue, xKey, xName, xValue, yKey, yName, yValue } = params;  // yKey is the colId, yValue is the value you want
                                    const { processedYValue, yKey } = params;
                                    //console.log('tooltip params', params);
                                    return {  // return an object with { title, content } - supports HTML
                                        title: getReplyNameFromColId(yKey),
                                        content: valueFormatter(processedYValue),
                                    };
                                },
                            },
                        },
                        title: {
                            enabled: true,
                            text: `${this.title} - ${label}`,
                        },
                        legend: {
                            enabled: true,
                            item: {
                                label: {
                                    formatter: (params) => {
                                        // const { id, itemId, value } = params;  // itemId is the column ID - use that to get better label
                                        //console.log('params of legend formatter', params);
                                        const { itemId } = params;
                                        const replyObj = this.colIdReplyMap[itemId];
                                        return replyObj ? getReplyNameFromColId(itemId) : params.value;  // ?.company?.name ?? params.value;
                                    },
                                },
                            },
                        },
                    },
                },
                unlinkChart: false,  // unlink will make it not highlight the cells its charting
            };
            this.gridApi.createRangeChart(params);
        },
        // TODO - build a multiple-smartform version of this, to put all parts / smartforms in one chart
        buildSmartFormRows: function(smartFormData, replies) {
            // build up and return gridRows - array of row data objects to show in grid
            // some important things (nested_path, data_path) are added in backend
            const formFields = smartFormData.compare_grid_fields;  // ARRAY of objects
            let gridRows = [];  // build this up and return it -- will be array of FormiumFormCompareGridRow
            // FOR ANY ADDITIONAL CONFIG, YOU CAN ADD THINGS TO SmartForm itself and use that to figure out what to show, how to group, etc... 
            formFields.forEach(fld => {
                // new Sept 5 2022 - as you go, look for any with expand: true and push to smartFormDefaultExpandIds array
                if (fld.expand) {
                    this.smartFormDefaultExpandIds.push(fld.id);
                }
                let newGridRow = new SmartFormCompareGridRow({smartform_field: fld, replies });
                gridRows.push(newGridRow);
            });
            //console.log('smartFormRows', gridRows);
            return gridRows;
        },
        buildQuoteSheetRows: function(quoteSheetData, replyList) {
            // pass in complete QuoteSheetData with nested line items, and all replies, all from API... build everything
            // each ROW in the grid represents one QuoteSheetItemVariant, together with bids from each vendor
            // stash all top-level metadata about each vendor/response in the grid context
            const qsItems = quoteSheetData.quotesheet_items;  // array of QuoteSheetItems with 'linked_product' and 'variants' nested inside
            let gridRows = [];  // we'll build this up and return it - instances of CompareGridRow -- flat, but we'll use row groups to group things
            // we'll first build up all row data with only items/variants, then we'll add bids to each one separately as we loop through all responses/companies
            qsItems.forEach(item => {
                // check if there are more than one variant... if there are FOR ANY ITEM, set this.hasMultipleVariants = true
                if (item.variants.length > 1) { this.hasMultipleVariants = true; }
                item.variants.forEach(variant => {  // loop through all variants... we are not building tree data, but will use row grouping instead
                    gridRows.push(new CompareGridRow({
                        item: new QsItemForReply(item),
                        variant: new QsItemVariantForReply(variant),
                        replies: replyList,
                    }));
                });
            });
            // ADD GRAND TOTAL ROW - if enable_subtotal = true
            // this will be a dummy row, we'll make up stuff so it uses same schema as other things - or make it on backend?
            if (quoteSheetData.enable_subtotal) {
                const grandTotalItem = {
                    id: 'GRAND_TOTAL_ITEM', // dummy ID - not used other places?  but grand total VARIANT id is more important, used other places
                    name: 'Grand Total',
                    // description
                    guid: uuidv4(),  // it expects this
                    quotesheet_id: quoteSheetData.id,
                };
                const grandTotalVariant = {
                    id: grandTotalVariantId,
                    guid: uuidv4(),
                    // need any others??? 
                };
                // add GRAND TOTAL ROW to gridRows
                gridRows.push(new CompareGridRow({
                    item: grandTotalItem,
                    variant: grandTotalVariant,
                    replies: replyList,
                }));
            }
            // now we have gridRows with item/variant info, now we'll loop through all replies/responses and add bids to each row
            // each reply has 'variant_bid_map' -- an object with keys of variant_id, values of full bid object
            /* replyList.forEach(reply => {
                const reply_id = reply.id;
                const bid_map = reply.variant_bid_map ?? {};  // use nullish coalescing to make sure we have an object here so we don't throw error below
                const isLatest = reply.is_latest;  // is this the LATEST reply from the company who submitted it?  we only use these for analysis cols
                gridRows.forEach(row => {  // row.id is the variant.id, same as key in bid_map
                    const bidData = bid_map[row.id];  // bid_map[row.id] might return undefined, which is OK
                    const bidObj = bidData ? new QuoteSheetReplyBid(bidData) : null;
                    row.addBid(reply_id, bidObj, isLatest);
                });
            }); */
            // ADD PSEUDO-BIDS? best price, target price, etc. - have to add the data to the gridRows
            // not needed?  just add other attributes on CompareGridRow class so you don't have extra bids to confuse your min/max logic
            return gridRows;
        },
        buildFormiumFormRows: function(formiumFormData, replies) {
            // get list of QUESTIONS from formiumFormData.active_items -- Array of objects - important keys are 'id' 'label' 'choices' 'currency' 'field_type_slug'
            // get ANSWERS from replies --> reply.formium_data_map -- an object with keys as IDs of active_items, values as primitive values (strings, arrays of strings, etc.)
            const formiumItems = formiumFormData.active_items;  // ARRAY of objects
            let gridRows = [];  // build this up and return it -- will be array of FormiumFormCompareGridRow
            // loop through formiumItems, create instances of FormiumFormCompareGridRow, then add replies
            formiumItems.forEach(item => {
                let newGridRow = new FormiumFormCompareGridRow({formium_item: item});
                // now loop through all replies, get the answer from each for this formium item, and addReply
                replies.forEach(reply => {
                    const replyValue = reply.formium_data_map[item.id];  // formium_data_map is object with keys being formium_item.id, values are answers to the questions -- this could be undefined if supplier didn't answer question!
                    newGridRow.addReply(reply.id, replyValue);  // replyValue might be undefined!  do you want a default???  no, you may want to show something specific in the grid if undefined/not answered
                });
                gridRows.push(newGridRow);
            });
            // add any pseudo-bids?  these would be extra things in the FormiumFormCompareGridRow
            return gridRows;
        },
        buildDocRequestRows: function(docRequestData, replies) {
            // docRequestData is a simple object, only has nested data in 'template_file' if dr_type is 'template'
            // replies has reply.docrequest_reply_data.comment and reply.docrequest_reply_data.upload (upload has nested file data in it)
            // we'll make just a few rows, since there aren't any 'line items' for this type
            let gridRows = [];  // build this up and return it
            const drRows = docRequestRows.filter(drr => drr.showInCompareGrid);  // imported at the top from helper file - has valueFormatter too
            drRows.forEach(dr => {
                let newGridRow = new DocRequestCompareGridRow({dataKey: dr.dataKey, label: dr.label, docrequest: docRequestData});
                // now add the replies
                replies.forEach(reply => {
                    const drReplyData = reply.docrequest_reply_data;
                    newGridRow.addReply(reply.id, drReplyData);
                });
                gridRows.push(newGridRow);
            });
            // add any pseudo-columns?  
            return gridRows;
        },
        buildColDefs: function(replyList) {
            // return the array of colDefs for ag-grid -- rows are CompareGridRow objects
            // STANDARD ITEM/VARIANT COLS - DO THIS DYNAMICALLY BASED ON this.category
            // NEW May 14 2022 - we will also build up a mapping of { colId: replyObj }
            //      to use it when getting labels for charts, etc.
            let standardColDefs = [];  // default... then set based on this.category
            let analysisColDefs = [];  // default...
            if (this.category === 'quotesheet') {
                standardColDefs = this.getStandardColDefsQuoteSheet();
                analysisColDefs = this.buildQuoteSheetAnalysisColDefs();
                this.buildQuoteSheetVendorColControls();
            } else if (this.category === 'formium_form') {
                standardColDefs = this.getStandardColDefsFormiumForm();
            } else if (this.category === 'docrequest') {
                standardColDefs = this.getStandardColDefsDocRequest();
            } else if (this.category === 'smartform') {
                standardColDefs = this.getStandardColDefsSmartForm();
                analysisColDefs = this.buildSmartFormAnalysisColDefs();
            }
            // BUILD COLUMN GROUPS FOR EACH COMPANY, then each REPLY for that company (allows showing multiple replies per company)
            // figure out the unique companies you have replies for
            const companyIdSet = new Set();
            const companyObjSet = new Set();
            replyList.forEach(rep => {
                if (!companyIdSet.has(rep.company_id)) {
                    companyIdSet.add(rep.company_id);
                    companyObjSet.add(rep.company);
                }
            });
            const companyObjects = Array.from(companyObjSet);
            const getSubmittedTimestamp = (replyObj) => {
                return DateTime.fromISO(replyObj.submitted_on).toSeconds();
            }
            const getReplyListForCompanyId = (compId) => {
                // returns list sorted in DESCENDING order by submitted_on date (latest first)
                const replies = replyList.filter(rep => rep.company_id == compId);
                return orderBy(replies, [getSubmittedTimestamp], ['desc']);
            };
            const companyColGroups = [];
            companyObjects.forEach(comp => {
                const companyReplyList = getReplyListForCompanyId(comp.id);
                const hasMultipleReplies = companyReplyList.length > 1;
                // STASH IN this.companyReplyMap  (maybe we should do this as soon as we get data from API?)
                const replyMapForCompany = Object.fromEntries(companyReplyList.map(rep => ([rep.id, rep])));  // Object with replies for this company, keyed by replyId
                const companyObjectWithReplies = { ...comp, replies: replyMapForCompany, hasMultipleReplies };  
                this.companyReplyMap[comp.id] = companyObjectWithReplies;
                // continue building colDefs for the company and nested cols...
                console.log(`companyReplyList for company ${comp.name}`, companyReplyList);
                const companyReplyCols = [];
                companyReplyList.forEach((replyObj, index) => {
                    // NOW ADDING THIS IN BACKEND const isLatest = index == 0;  // is it the first one?  then its the latest
                    const replyCol = this.buildReplyColDef(replyObj, index);  // likely (but not always) one reply per company
                    companyReplyCols.push(replyCol);
                    //this.colIdReplyMap[replyCol.colId] = replyObj;  // add to the mapping of ALL reply cols for looking up things about the reply (for charts, etc.)
                    // NOTE - for QuoteSheets, replyCols are GROUP COLUMNS - they have other cols inside.... so might need to modify for that
                });
                const companyColGroup = {
                    headerName: comp.name,
                    headerClass: ['vendor-col', 'company-group-header'],
                    groupId: comp.id,
                    headerGroupComponent: 'vendorReplyColGroupHeader',
                    headerGroupComponentParams: {
                        // REMOVE subheading: replyObj.submitted_on,
                        componentParent: this, // seems colGroupHeader components don't have access to context, so need to add link to parent this way
                        // TODO - remove reference to replyObj - use RfxResponse instead?
                        //reply: replyObj, // pass in the complete reply object so we can emit it if needed
                        companyId: comp.id,
                        hasMultipleReplies: hasMultipleReplies,
                        // pass in more params, like text to use for main actions button, data for other actions, what to report back in actions, etc.
                    },  // an object with any extra params for your custom headerGroupComponent
                    marryChildren: true,  // too confusing if they aren't always next to each other
                    children: companyReplyCols,
                    toolPanelClass: ['bg-primary-50', 'font-weight-bold'],
                    suppressColumnsToolPanel: false,  // setting to true will disable all cols in the group and the group
                };
                companyColGroups.push(companyColGroup);
                this.companyColGroupIdSet.add(companyColGroup.groupId);  // Set to track of all the colGroup.groupId for easily working with cols using gridColumnApi later
            })
            /// build NESTED arrays of reply cols for use in check-boxes, etc.
            const availableCompanyObjectsForCheckboxes = companyColGroups.map(compCol => {
                return {
                    companyId: compCol.groupId,
                    companyName: String(compCol.headerName),
                    hasMultipleReplies: compCol.children.length > 1,
                    replies: compCol.children.map(replyCol => {
                        return {
                            replyId: replyCol.replyId,  // we sent this along for the ride for this purpose
                            value: replyCol.replyId,  // in QuoteSheets the children are groups, but not for the others
                            text: `${compCol.headerName} - ${replyCol.submittedOnString}${replyCol.isLatest ? ' (LATEST)' : ''}`, // replyCol.headerName,
                            companyId: compCol.groupId,
                            companyName: compCol.headerName,
                            submittedOnString: replyCol.submittedOnString,
                            isLatest: replyCol.isLatest,
                        };
                    }),
                };
            });
            // ORDER BY by company name (lowercase)
            this.availableReplyColsByCompany = orderBy(availableCompanyObjectsForCheckboxes, [function(c) {return c.companyName?.toLowerCase();}], ['asc']);
            // now make flat version for use in other places...
            const availableReplyColsFlat = [];
            this.availableReplyColsByCompany.forEach(nested => {
                availableReplyColsFlat.push(...nested.replies);
            });
            this.availableReplyCols = availableReplyColsFlat;
            // later... implement a store for toggling visibility of reply cols?
            // this.replyToggleStore = Object.fromEntries(availableReplyColsFlat.map(r => [r.replyId, {isVisible: true, ...r}]));  // set all to visible by default
            // console.log('replyToggleStore', this.replyToggleStore);
            this.visibleReplyIds = availableReplyColsFlat.map(reply => reply.value);  // set all to visible by default
            // COMBINE AND RETURN
            //let allColDefs = [...standardColDefs, ...replyColGroups, ...analysisColDefs];
            let allColDefs = [...standardColDefs, ...companyColGroups, ...analysisColDefs];
            this.$devlog('Here is allColDefs');
            this.$devlog(allColDefs);
            return allColDefs;
        },
        buildQuoteSheetVendorColControls: function() {
            if (!this.quoteSheetData) return; // can only do this if we have quoteSheetData (working with a quote sheet and have data)
            const enabledVendorCols = this.quoteSheetData.getEnabledVendorCols();  // array from vendorColsAll, filtered for ONLY enabled ones on QuoteSheet level (not row level), includes any choices arrays from backend
            //console.log('enabledVendorCols', enabledVendorCols);
            // SET available options and initial value for quoteSheetVisibleVendorColIds -- get the plainKey from enabledVendorCols
            const showQuotedCurrencyCols = this.quoteSheetData.has_multiple_quoted_currency_options ?? false;
            const specialQuotedCols = [ // keys here are special ones, if in here, then use the value for the key in the object to know what to show
                {plainKey: 'quoted_price', useIfKey: 'price'},
                {plainKey: 'quoted_subtotal', useIfKey: 'subtotal'},
            ];
            const specialQuotedColKeys = specialQuotedCols.map(scol => scol.plainKey);
            const availableColKeys = enabledVendorCols.filter(vcol => {
                // skip any special ones, add them later
                if (specialQuotedColKeys.includes(vcol.plainKey)) return false;
                // we skip any that are hidden by default for compare grid
                const isHiddenInCompareGrid = vcol.compareGrid?.hide ?? false;
                return !isHiddenInCompareGrid;
            }).map(vcol => vcol.plainKey);  // just get the plainKey
            specialQuotedCols.forEach(scol => {
                if (showQuotedCurrencyCols && availableColKeys.includes(scol.useIfKey)) {
                    availableColKeys.push(scol.plainKey);  // add the special one
                }
            });
            // finally, go back through enabledVendorCols and build the list of objects we want to use for the dropdown based on whats in availableColKeys
            this.quoteSheetAvailableVendorCols = enabledVendorCols.filter(vcol => availableColKeys.includes(vcol.plainKey)).map(vcol => {
                return {
                    value: vcol.plainKey, 
                    text: vcol.compareGrid.label || vcol.label,  // not all have specific labels set for compareGrid, fall back to default label
                };
            });  // FULL OBJECTS but with only the things we care about extracted
            this.quoteSheetVisibleVendorColIds = this.quoteSheetAvailableVendorCols.map(c => c.value);
            //console.log('quoteSheetAvailableVendorCols', this.quoteSheetAvailableVendorCols);
            //console.log('quoteSheetVisibleVendorColIds', this.quoteSheetVisibleVendorColIds);
        },
        buildReplyColDef: function(replyObj, replyIndex) {  // isLatest == 'is this the latest version of reply from this company?'
            // builds the individual colDefs for EACH REPLY (in each group)
            if (this.category === 'quotesheet') {
                return this.buildReplyColDefQuoteSheet(replyObj, replyIndex);
            } else if (this.category === 'formium_form') {
                return this.buildReplyColDefFormiumForm(replyObj, replyIndex);
            } else if (this.category === 'docrequest') {
                return this.buildReplyColDefDocRequest(replyObj, replyIndex);
            } else if (this.category === 'smartform') {
                return this.buildReplyColDefSmartForm(replyObj, replyIndex);
            }
        },
        buildReplyColDefSmartForm: function(replyObj, replyIndex) {
            // build a colDef for a single column, for a single vendor reply
            // June 13 2022 - return a SINGLE COL DEF (not array of them)
            const replyId = replyObj.id;
            const isLatest = replyObj.is_latest;
            //const companyName = replyObj.company?.name ?? '';
            // just return one column for formium_form -- the answer
            const colId = replyId; // `smartform_value_${replyId}`;  // just the replyId for these with only one datapoint per reply
            this.replyIdToColIds[replyId] = [colId];  // for consistent way to show/hide cols for all/latest replies toggle
            this.colIdReplyMap[colId] = replyObj;  // add to the mapping of ALL reply cols for looking up things about the reply (for charts, etc.)
            const smartFormCellClassRules = {
                'is-min-price': (params) => params.data && params.colDef.isLatest && (params.colDef.replyId == params.data.minReplyId),
                'is-max-price': (params) => params.data && params.colDef.isLatest && (params.colDef.replyId == params.data.maxReplyId),
            };
            const headerClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'smartform-value', 'center', ['reply-group-header']);  // forcing all headers of these cols to CENTER alignment (looks better?) - can add a final arg for any extraClasses
            const allCellClassRules = this.buildReplyColCellClassRules(smartFormCellClassRules);  // can pass in an object with more cellClassRules
            // for formium_forms, we may want to pass a FUNCTION to cellClass, in addition to cellClassRules
            // because different rows/formium items may need different CSS classes... if so, then first use method below to build list of 'fixed' classes, make a function that combines those
            const cellClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'smartform-value', 'center', ['smartform-value']);  // final arg for any extraClasses
            const submittedOnString = FormatDateHelper(replyObj.submitted_on);
            return {
                headerName: `Submitted ${submittedOnString}${ isLatest ? ' - LATEST' : ''}`,  // used in column sidebar tool - still important
                headerClass: headerClasses,
                //companyName: replyObj.company?.name ?? '',  // extra thing we pass through
                //companyId: replyObj.company_id,
                // EXTRA STUFF TO SEND ALONG FOR THE RIDE, not used in grid, but in our own stuff like toggles
                replyId: replyId,  // send this along for the ride in the colDef...
                submittedOnString: submittedOnString,  // send this along for the ride in the colDef...
                isLatest: isLatest,  // send this along for the ride, using in in our checkbox toggles
                //type: '',
                chartDataType: 'series',
                colId: colId,
                field: 'smartform_value',
                headerTooltip: isLatest ? 'LATEST response from this supplier' : 'Previous (outdated) response from this supplier',
                editable: false,
                minWidth: 150,
                maxWidth: 500,
                hide: false,
                suppressColumnsToolPanel: false,
                //toolPanelClass: ['d-none'],  // don't hide this... but not sure what else to do with it... maybe get rid of group header for formium form?
                valueGetter: smartFormValueGetter,
                valueFormatter: smartFormValueFormatter,
                cellClass: cellClasses,
                cellClassRules: allCellClassRules,
                // SKIP FOR NOW cellRenderer: 'smartFormValueCellRenderer',  // can help control layout in the cell
                // we just added extra padding using CSS -- it works, even with autoHeight
                headerComponent: 'singleReplyHeaderRenderer',
                headerComponentParams: {
                    isLatest: isLatest,
                    submittedOnString: submittedOnString,
                },
            };
        },
        buildReplyColDefFormiumForm: function(replyObj, replyIndex) {
            // June 13 2022 - return a SINGLE COL DEF (not array of them)
            const replyId = replyObj.id;
            const isLatest = replyObj.is_latest;
            const colId = replyId;  // `formium_value_${replyId}`;  // just replyId for these with only one datapoint per reply
            this.replyIdToColIds[replyId] = [colId];  // for consistent way to show/hide cols for all/latest replies toggle
            this.colIdReplyMap[colId] = replyObj;  // add to the mapping of ALL reply cols for looking up things about the reply (for charts, etc.)
            const allCellClassRules = this.buildReplyColCellClassRules();  // can pass in an object with more cellClassRules
            // for formium_forms, we may want to pass a FUNCTION to cellClass, in addition to cellClassRules
            // because different rows/formium items may need different CSS classes... if so, then first use method below to build list of 'fixed' classes, make a function that combines those
            const cellClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'formium_value', 'left', ['formium-value']);  // final arg for any extraClasses
            const headerClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'formium_value', 'center', ['reply-group-header']);  // forcing all headers of these cols to CENTER alignment (looks better?) - can add a final arg for any extraClasses
            const submittedOnString = FormatDateHelper(replyObj.submitted_on);
            return {
                headerName: `Submitted ${submittedOnString}${ isLatest ? ' - LATEST' : ''}`,   // used in column sidebar tool - still important
                headerClass: headerClasses,
                //companyName: replyObj.company?.name ?? '',  // extra thing we pass through
                //companyId: replyObj.company_id,
                // EXTRA STUFF TO SEND ALONG FOR THE RIDE, not used in grid, but in our own stuff like toggles
                replyId: replyId,  // send this along for the ride in the colDef...
                submittedOnString: submittedOnString,  // send this along for the ride in the colDef...
                isLatest: isLatest,  // send this along for the ride, using in in our checkbox toggles
                //type: '',
                colId: colId,
                field: 'formium_value',
                headerTooltip: isLatest ? 'LATEST response from this supplier' : 'Previous (outdated) response from this supplier',
                editable: false,
                minWidth: 150,
                maxWidth: 500,
                hide: false,
                suppressColumnsToolPanel: false,
                //toolPanelClass: ['d-none'],  // don't hide this... but not sure what else to do with it... maybe get rid of group header for formium form?
                valueGetter: formiumFormValueGetter,
                //valueFormatter: formiumFormValueFormatter,  // we COMBINED valueGetter and valueFormatter so we just output already formatted strings - see notes at the top
                cellClass: cellClasses,
                cellClassRules: allCellClassRules,
                // SKIP FOR NOW cellRenderer: 'formiumValueCellRenderer',  // using a special renderer for all 'answer' cells in formium form to control padding, etc.
                // we just added extra padding using CSS -- it works, even with autoHeight
                headerComponent: 'singleReplyHeaderRenderer',
                headerComponentParams: {
                    isLatest: isLatest,
                    submittedOnString: submittedOnString,
                },
            };
        },
        buildReplyColDefDocRequest: function(replyObj, replyIndex) {
            // June 13 2022 - return a SINGLE COL DEF (not array of them)
            const replyId = replyObj.id;
            const isLatest = replyObj.is_latest;
            this.$devlog("docRequestValueCellRendererMap");
            this.$devlog(docRequestValueCellRendererMap);
            // just return one column for docrequests
            const colId = replyId;  // `docrequest_data_${replyId}`;  // just replyId for these with only one datapoint per reply
            this.replyIdToColIds[replyId] = [colId];  // for consistent way to show/hide cols for all/latest replies toggle
            this.colIdReplyMap[colId] = replyObj;  // add to the mapping of ALL reply cols for looking up things about the reply (for charts, etc.)
            const allCellClassRules = this.buildReplyColCellClassRules();  // can pass in an object with more cellClassRules
            // for formium_forms, we may want to pass a FUNCTION to cellClass, in addition to cellClassRules
            // because different rows/formium items may need different CSS classes... if so, then first use method below to build list of 'fixed' classes, make a function that combines those
            const cellClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'docrequest_data', 'center', ['docrequest-data']);  // final arg for any extraClasses
            const headerClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'docrequest_data', 'center', ['reply-group-header']);  // forcing all headers of these cols to CENTER alignment (looks better?) - can add a final arg for any extraClasses
            const submittedOnString = FormatDateHelper(replyObj.submitted_on);
            return {
                headerName: `Submitted ${submittedOnString}${ isLatest ? ' - LATEST' : ''}`,   // used in column sidebar tool - still important
                headerClass: headerClasses,
                //companyName: replyObj.company?.name ?? '',  // extra thing we pass through
                //companyId: replyObj.company_id,
                // EXTRA STUFF TO SEND ALONG FOR THE RIDE, not used in grid, but in our own stuff like toggles
                replyId: replyId,  // send this along for the ride in the colDef...
                submittedOnString: submittedOnString,  // send this along for the ride in the colDef...
                isLatest: isLatest,  // send this along for the ride, using in in our checkbox toggles
                //type: '',
                colId: colId,
                field: 'docrequest_data',
                headerTooltip: isLatest ? 'LATEST response from this supplier' : 'Previous (outdated) response from this supplier',
                editable: false,
                minWidth: 150,
                maxWidth: 500,
                hide: false,
                suppressColumnsToolPanel: false,
                //toolPanelClass: ['d-none'],  // don't hide this... but not sure what else to do with it... maybe get rid of group header for formium form?
                valueGetter: docRequestValueGetter,
                cellRendererSelector: (params) => docRequestValueCellRendererMap.get(params.node.id),  // params.node.id is the dataKey for this row
                //valueFormatter: formiumFormValueFormatter,  // we COMBINED valueGetter and valueFormatter so we just output already formatted strings - see notes at the top
                cellClass: cellClasses,
                cellClassRules: allCellClassRules,
                headerComponent: 'singleReplyHeaderRenderer',
                headerComponentParams: {
                    isLatest: isLatest,
                    submittedOnString: submittedOnString,
                },
            };
        },
        buildReplyColDefQuoteSheet: function(replyObj, replyIndex) { 
            // NEW - June 13 2022 -- return a single colDef, WITH NESTED CHILD COLDEFS for a single replyObj -- unlike other types of todos, this has another level of nested cols
            const replyId = replyObj.id;
            const isLatest = replyObj.is_latest;
            let vendorColDefs = [];  // we'll build this up
            const enabledVendorCols = this.quoteSheetData.getEnabledVendorCols();  // array from vendorColsAll, filtered for ONLY enabled ones on QuoteSheet level (not row level), includes any choices arrays from backend
            //const companyName = replyObj.company?.name ?? '';  // extra thing we pass through into colDef
            //const companyId = replyObj.company_id;  

            const conditionalSet = (object, property, value, defaultValue) => {
                // helper to use below, pass in colDef as object, property you want to set as property, something from vcol as value, and optional default
                // if no value and no defaultValue, it does not set the property on object
                // this is useful in case you want to allow 'type' to set certain properties, you can't also define them in each colDef because they'll override 'type'
                const valueToSet = (value || defaultValue) ?? null;
                if (valueToSet === null) return;  // if both value and defaultValue were null/undefined, then don't set this on colDef, let it fall back to defaultColDef or 'type'
                // otherwise the property on object
                object[property] = valueToSet;
            };

            const vcolSkipFields = ['nobid'];  // June 14 2022 - we will always skip these  (were previously making colDefs for them, but then hiding them)
            enabledVendorCols.forEach(vcolOriginal => {
                this.$devlog(`Building vcol ${vcolOriginal.plainKey}`);
                const vcol = cloneDeep(vcolOriginal);
                const showQuotedCurrencyCols = this.quoteSheetData.has_multiple_quoted_currency_options ?? false;
                const quotedCurrencyColKeys = ['quoted_price', 'quoted_subtotal'];
                if (!showQuotedCurrencyCols && quotedCurrencyColKeys.includes(vcol.plainKey)) {
                    // we have a column for multi-currency stuff, but do not need to show it -- just move on
                    return;
                } 
                this.$devlog(vcol);
                let colDef = {};
                const headerClasses = this.buildReplyColCellClasses(replyObj, replyIndex, vcol.plainKey, 'center', vcol.compareGrid.headerClass);  // forcing all headers of these cols to CENTER alignment (looks better?) - can add a 3rd arg for any extraClasses
                const cellClasses = this.buildReplyColCellClasses(replyObj, replyIndex, vcol.plainKey, vcol.compareGrid.alignment, vcol.compareGrid.cellClass);  // 3rd arg for any extraClasses
                const colId = `${vcol.plainKey}_${replyId}`;  // something like 'price_2lksjdfsd88ss9dfssfsd'
                const allCellClassRules = this.buildReplyColCellClassRules(vcol.compareGrid.cellClassRules);
                conditionalSet(colDef, 'headerName', vcol.compareGrid.label, vcol.label);
                conditionalSet(colDef, 'headerClass', [...headerClasses, 'quotesheet-vcol-header']);
                //conditionalSet(colDef, 'companyName', companyName);
                //conditionalSet(colDef, 'companyId', companyId);
                conditionalSet(colDef, 'replyId', replyId);  // still need replyId here for quote sheets
                colDef.isLatest = isLatest;
                conditionalSet(colDef, 'type', vcol.compareGrid.type, null);
                conditionalSet(colDef, 'colId', colId);
                conditionalSet(colDef, 'field', vcol.compareGrid.field, vcol.plainKey);
                conditionalSet(colDef, 'headerTooltip', vcol.compareGrid.tooltip, (vcol.compareGrid.label || vcol.label));
                conditionalSet(colDef, 'editable', false, false);  // just set it to false directly (need default of false)
                conditionalSet(colDef, 'minWidth', vcol.compareGrid.minWidth);
                conditionalSet(colDef, 'maxWidth', vcol.compareGrid.maxWidth);
                const isTotallyHidden = !!vcol.compareGrid.hide;
                //conditionalSet(colDef, 'hide', (vcol.compareGrid.hide ? true : false));
                conditionalSet(colDef, 'hide', isTotallyHidden);
                //conditionalSet(colDef, 'suppressColumnsToolPanel', (vcol.compareGrid.hide ? true : false));
                conditionalSet(colDef, 'suppressColumnsToolPanel', isTotallyHidden);
                conditionalSet(colDef, 'suppressFiltersToolPanel', isTotallyHidden);
                conditionalSet(colDef, 'valueGetter', vcol.compareGrid.valueGetter, quoteSheetValueGetter);
                conditionalSet(colDef, 'valueFormatter', vcol.compareGrid.valueFormatter);
                conditionalSet(colDef, 'cellClass', cellClasses);
                conditionalSet(colDef, 'cellClassRules', allCellClassRules);
                conditionalSet(colDef, 'cellRenderer', vcol.compareGrid.cellRenderer);
                conditionalSet(colDef, 'cellRendererParams', vcol.compareGrid.cellRendererParams);
                conditionalSet(colDef, 'tooltipValueGetter', vcol.compareGrid.tooltipValueGetter);
                if (!vcolSkipFields.includes(vcol.compareGrid?.field)) {
                    vendorColDefs.push(colDef);  // probably could put this conditional check up top...
                }
            });
            // NEW June 13 2022 - now build up the single colDef for the reply... with vendorColDefs in it
            const submittedOnString = FormatDateHelper(replyObj.submitted_on);
            //const cellClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'quotesheet-value', 'center', ['smartform-value']);  // final arg for any extraClasses
            const headerClasses = this.buildReplyColCellClasses(replyObj, replyIndex, 'quotesheet-value', 'center', ['reply-group-header']);  // forcing all headers of these cols to CENTER alignment (looks better?) - can add a final arg for any extraClasses
            const replyColDef = {  // a GROUP colDef
                headerName: `Submitted ${submittedOnString}${ isLatest ? ' - LATEST' : ''}`,   // used in column sidebar tool - still important
                headerClass: headerClasses,
                groupId: replyId,
                //field: 'smartform_value',
                headerTooltip: isLatest ? 'LATEST response from this supplier' : 'Previous (outdated) response from this supplier',
                //editable: false,
                minWidth: 150,
                maxWidth: 500,
                hide: false,
                marryChildren: true,  // too confusing if they aren't always next to each other
                children: vendorColDefs,
                toolPanelClass: ['bg-primary-50', 'font-weight-bold'],
                suppressColumnsToolPanel: false,  // setting to true will disable all cols in the group and the group
                //toolPanelClass: ['d-none'],  // don't hide this... but not sure what else to do with it... maybe get rid of group header for formium form?
                //valueGetter: smartFormValueGetter,
                //valueFormatter: smartFormValueFormatter,
                //cellClass: cellClasses,
                //cellClassRules: allCellClassRules,
                headerGroupComponent: 'singleReplyHeaderRenderer',
                headerGroupComponentParams: {
                    isLatest: isLatest,
                    submittedOnString: submittedOnString,
                },
                // SKIP FOR NOW cellRenderer: 'smartFormValueCellRenderer',  // can help control layout in the cell
                // we just added extra padding using CSS -- it works, even with autoHeight
                // EXTRA STUFF TO SEND ALONG FOR THE RIDE, not used in grid, but in our own stuff like toggles
                replyId: replyId,  // send this along for the ride in the colDef...
                submittedOnString: submittedOnString,  // send this along for the ride in the colDef...
                isLatest: isLatest,  // send this along for the ride, using in in our checkbox toggles
            };
            // stash things in lookup maps for later use:
            this.replyIdToColIds[replyId] = vendorColDefs.map(vcol => vcol.colId);  // for consistent way to show/hide cols for all/latest replies toggle
            vendorColDefs.forEach(vcol => {
                this.colIdReplyMap[vcol.colId] = replyObj;  // add to the mapping of ALL reply cols for looking up things about the reply (for charts, etc.)
            });
            return replyColDef;
        },
        // HELPERS FOR MAKING SUB-COLS FOR REPLY COLUMNS
        buildReplyColCellClasses: function(replyObj, replyIndex, fieldName, alignment, extraClassesArray) {
            // helper to build sub-columns in Reply colGroups in a consistent way
            // fieldName and alignment are strings, extraClassesArray is ARRAY of strings
            // CALL THIS when building colDefs -- don't pass the function, pass the RETURN of this function
            // return an ARRAY of classes -- you _could_ return a function like you're doing above for buildCellRendererSelector, but no need right now
            const replyId = replyObj.id;
            const isLatest = replyObj.is_latest;
            const latestOrPreviousClass = isLatest ? 'latest' : 'previous';
            let allCellClasses = ['vendor-col', `reply-${replyId}`, `reply-${replyIndex}`, latestOrPreviousClass];  // start with this, then add to it - put any defaults in here
            if (alignment) {
                allCellClasses.push('column-align-' + alignment);
            } 
            if (fieldName) {
                allCellClasses.push('vendor-col-' + fieldName);  
            }
            if (!!extraClassesArray && Array.isArray(extraClassesArray) && extraClassesArray.length) {  // important to check all these things, in this order
                allCellClasses = allCellClasses.concat(extraClassesArray);
            }
            return allCellClasses.length ? allCellClasses : null;  // return null if its an empty array
        },
        buildReplyColCellClassRules: function(cellClassRulesObj) {
            // helper function to MERGE cellClassRules objects -- from a lookup, and some hard-coded ones here
            // merges any cellClassRules passed in with some standard ones - thing passed in should be an OBJECT
            const standardRules = {
                'first-col-in-group': params => isFirstColInGroup(params),
            };
            let finalRules = Object.assign({}, standardRules);
            return cellClassRulesObj ? Object.assign(finalRules, cellClassRulesObj) : finalRules;
        },
        // GRID EVENT HANDLERS AND CALLBACKS
        dumpGrid: function() {
            // just dump grid data to console for testing
            let gData = [];
            let allNodes = [];
            this.gridApi.forEachNode((node, index) => {
                allNodes.push(node);
                gData.push({
                    grid_index: index,
                    ...node.data,
                });
            });
            let columnState = this.gridColumnApi.getColumnState();
            let columnGroupState = this.gridColumnApi.getColumnGroupState();
            console.log('NODES:');
            console.log(allNodes);
            console.log('ROW DATA:');
            console.log(gData);
            console.log('getFirstDisplayedRow');
            console.log(this.gridApi.getFirstDisplayedRow());
            console.log('getLastDisplayedRow');
            console.log(this.gridApi.getLastDisplayedRow());
            console.log('getColumnState');
            console.log(columnState);
            console.log('getColumnGroupState');
            console.log(columnGroupState);
        },
        resetColumns: function() {
            // reset original colDefs
            if (this.isQuoteSheet) {
                this.showAllQuoteSheetVendorCols();
                this.showAllQuoteSheetItemCols();
            }
            this.showAllAnalysisCols();
            this.showAllReplies();
            this.gridColumnApi.resetColumnState();
            // may also have to do resetColumnGroupState()
        },
        updateRowHeights: function(params) {  // triggered by @column-resized event
            console.log('called updateRowHeights - params', params);
            //console.log(params);
            if (params && (params.finished !== false)) {  // check if finished, if params has that... it may not
                this.$devlog('updating row heights');
                this.gridApi.resetRowHeights();
                //params.api.resetRowHeights();  // don't use this, so you can call this from anywhere
            } else if (!params) {
                // but maybe we called from a place without passing in params... 
                this.$devlog('updating row heights');
                this.gridApi.resetRowHeights();
            }
            // now also update header group heights! -- we try wrapping in nextTick to make sure the grid has updated the heights... but doesn't seem to work.... so using setTimeout
            // also only do this if we either don't have 'finished' in params, or if it's true
            const isNotFinished = params && (params.finished === false);
            if (isNotFinished) return;  // don't do the nextTick stuff if we're not finished -- could be dragging the column width
            setTimeout(() => {
                const replyHeaderMaxHeight = this.getReplyHeaderMaxHeight();
                if (replyHeaderMaxHeight > this.defaultGroupHeaderHeight) {
                    this.gridApi.setGroupHeaderHeight(replyHeaderMaxHeight);
                }
                if (replyHeaderMaxHeight < this.defaultGroupHeaderHeight) {
                    this.gridApi.setGroupHeaderHeight(this.defaultGroupHeaderHeight);
                }
            }, 300);
        },
        // isColCollapseVisible(collapseKey) {  // LATER... if needed
        //     // collapse key is one of the keys in colToggleCollapseVisible
        //     return this.colToggleCollapseVisible[collapseKey];
        // },
        // toggleColCollapse(collapseKey) {
        //     // collapse key is one of the keys in colToggleCollapseVisible
        //     if (this.colToggleCollapseVisible.hasOwnProperty(collapseKey)) {
        //         this.colToggleCollapseVisible[collapseKey] = !this.colToggleCollapseVisible[collapseKey];
        //     }
        // },
        showAllQuoteSheetVendorCols: function() {
            // this will trigger the @change event on the checkboxes, which will then show/hide the cols
            const allVendorCols = this.quoteSheetAvailableVendorCols.map(c => c.value);
            this.handleQuoteSheetVisibleVendorColsChange(allVendorCols);
        },
        hideAllQuoteSheetVendorCols: function() {
            this.handleQuoteSheetVisibleVendorColsChange([]);
        },
        showAllQuoteSheetItemCols: function() {
            // this will trigger the @change event on the checkboxes, which will then show/hide the cols
            const allItemCols = this.quoteSheetAvailableItemCols.map(c => c.value);
            this.handleQuoteSheetVisibleItemColsChange(allItemCols);
        },
        hideAllQuoteSheetItemCols: function() {
            this.handleQuoteSheetVisibleItemColsChange([]);
        },
        showAllAnalysisCols: function() {
            const allAnalysisColIds = this.availableAnalysisCols.map(col => col.value);
            this.handleVisibleAnalysisColsChange(allAnalysisColIds);
        },
        hideAllAnalysisCols: function() {
            this.handleVisibleAnalysisColsChange([]);
        },
        handleQuoteSheetVisibleItemColsChange: function(newValue) {
            const oldValue = [...this.quoteSheetVisibleItemColIds];
            console.log('item cols - oldValue -> newValue', oldValue, newValue);
            const showKeys = newValue.filter(k => !oldValue.includes(k));
            const hideKeys = oldValue.filter(k => !newValue.includes(k));
            console.log('item cols - showKeys', showKeys);
            console.log('item cols - hideKeys', hideKeys);
            this.quoteSheetVisibleItemColIds = [...newValue];  // set the new value to complete the 'v-model' loop
            this.gridColumnApi.setColumnsVisible(hideKeys, false);
            this.gridColumnApi.setColumnsVisible(showKeys, true);
            this.sizeColumnsToFit();
        },
        handleVisibleReplyColsChange: function(newValue) {
            // newValue is an array of replyIds that we want to be visible
            const oldValue = [...this.visibleReplyIds];
            console.log('reply cols - oldValue -> newValue', oldValue, newValue);
            const showReplyIds = newValue.filter(k => !oldValue.includes(k));
            const hideReplyIds = oldValue.filter(k => !newValue.includes(k));
            console.log('reply cols - showIds', showReplyIds);
            console.log('reply cols - hideIds', hideReplyIds);
            this.visibleReplyIds = [...newValue];  // set the new value to complete the 'v-model' loop
            // these are col groups so we need to get the individual colIds for each replyId
            const showColIds = this.getColIdsForReplyIds(showReplyIds);
            const hideColIds = this.getColIdsForReplyIds(hideReplyIds);
            this.gridColumnApi.setColumnsVisible(showColIds, true);
            this.gridColumnApi.setColumnsVisible(hideColIds, false);
            this.sizeColumnsToFit();
        },
        handleQuoteSheetVisibleVendorColsChange: function(newValue) {
            // triggered by @change/@input on checkboxes for quoteSheetVisibleVendorColIds array
            // THIS MUST SET THE NEW VALUE ALSO -- we do not use v-model for this array so we can know what exactly changes
            // we need to show/hide the cols based on the new list of visible cols
            // we don't have 'metadata' for the cols, so we have to compare things using their colId prefix... :(
            // NOTE - ideally, you should have external data holders of what is supposed to show (internal cols, vendor cols, latest/all, which vendors, etc.)
            // then you can just update the grid based on those data holders, when they change
            // but then you should hide the grid's internal controls for such things... just have external controls, or else it gets confusing
            const oldValue = [...this.quoteSheetVisibleVendorColIds];
            //const hadSomeColsVisible = oldValue.length > 0;  // if we had some cols visible before, then we do NOT show cols who are in a group with all cols hidden
            console.log('vendor cols - oldValue -> newValue', oldValue, newValue);
            const showVendorColKeys = newValue.filter(k => !oldValue.includes(k));
            const hideVendorColKeys = oldValue.filter(k => !newValue.includes(k));
            console.log('showVendorColKeys', showVendorColKeys);
            console.log('hideVendorColKeys', hideVendorColKeys);
            this.quoteSheetVisibleVendorColIds = [...newValue];  // set the new value to complete the 'v-model' loop
            const allCols = this.gridColumnApi.getAllColumns();
            console.log('allCols', allCols);
            const hideColIds = [];
            const showColIds = [];
            // TODO - need to check if col GROUP is visible or hidden first....
            // loop through, check if colId starts with any of the keys in hideVendorColKeys or showVendorColKeys
            // but also must check if the group is already hidden or not 
            //console.log('this.replyIdToColIds', this.replyIdToColIds);
            allCols.forEach(col => {
                const colId = col.colId;
                const replyCol = col.getParent();  // might be undefined for non-vendor cols!  the parent is the group col for all things in one reply -- check if any children visible
                if (!replyCol) {
                    //console.log(`no replyCol for colId ${colId} so not doing anythingn with it`);
                    return;  // skip non-vendor cols
                } else {
                    //console.log(`got parent replyCol for colId ${colId}`, replyCol);
                }
                //const replyIsTotallyHidden = replyCol.displayedChildren.every(child => !child.visible);  // children or displayedChildren?  both should work
                const replyIsTotallyHidden = !this.visibleReplyIds.includes(replyCol.groupId);  // if the group col is not in the visibleReplyIds, then it's hidden
                //const doNotShow = replyIsTotallyHidden && hadSomeColsVisible;  // if we had some cols visible before (overall), but none showing for THIS reply, then leave this reply hidden
                if (hideVendorColKeys.some(k => colId.startsWith(`${k}_`))) {
                    hideColIds.push(colId);
                }
                if (showVendorColKeys.some(k => colId.startsWith(`${k}_`))) {
                    if (replyIsTotallyHidden) {
                        //console.log(`not showing colId ${colId} because replyIsTotallyHidden - dumping replyCol`, replyCol);
                        return;  // skip this one
                    } else {
                        showColIds.push(colId);
                    }
                }
            });
            this.gridColumnApi.setColumnsVisible(hideColIds, false);
            this.gridColumnApi.setColumnsVisible(showColIds, true);
            this.sizeColumnsToFit();
        },
        handleVisibleAnalysisColsChange: function(newValue) {
            // newValue is an array of colIds that we want to be visible for analysis cols
            const oldValue = [...this.visibleAnalysisColIds];
            console.log('analysis cols - oldValue -> newValue', oldValue, newValue);
            const showKeys = newValue.filter(k => !oldValue.includes(k));
            const hideKeys = oldValue.filter(k => !newValue.includes(k));
            console.log('analysis cols - showKeys', showKeys);
            console.log('analysis cols - hideKeys', hideKeys);
            this.visibleAnalysisColIds = [...newValue];  // set the new value to complete the 'v-model' loop
            this.gridColumnApi.setColumnsVisible(hideKeys, false);
            this.gridColumnApi.setColumnsVisible(showKeys, true);
            this.sizeColumnsToFit();
        },
        handleColumnVisible: function(event) {
            // need to refresh cells when we show/hide cols to refresh css classes
            this.$devlog('columnVisible event');
            this.$devlog(event);
            // event contains many things, including 'column' (column object that was updated) and 'columns' (array of column objects that was updated)
            // for now just refresh everything
            this.gridApi.refreshCells({suppressFlash: true});
            this.sizeColumnsToFit();  // this will also trigger updateRowHeights via event handler, but might miss it since we have animated transitions
        },
        handleFilterChanged: function() {  // can take event as arg, if you need it
            // we need to refresh cells when we filter so we reapply cellClassRules, especially for cells with d-none
            this.gridApi.refreshCells({suppressFlash: true});
            this.gridApi.redrawRows();  // need this to redraw the blue markers...
        },
        getReplyHeaderMaxHeight: function() {
            // return integer for the max height of the group header, so we can set new height - defaults to 0
            let replyGroupHeaders = Array.from(document.getElementsByClassName('ag-header-group-cell vendor-col'));  // make sure you still put vendor-col on each one!
            let replyGroupHeaderHeights = replyGroupHeaders.map(ele => {
                const innerHeaderElement = ele.getElementsByClassName('ag-header-group-text')[0];
                return innerHeaderElement ? innerHeaderElement.scrollHeight : null;
            }).filter(height => height);  // filter out any null values
            return (replyGroupHeaderHeights && replyGroupHeaderHeights.length) ? max(replyGroupHeaderHeights) : 0;
        },
        sizeColumnsToFit: function() {
            // use this for all sizing of columns to fit so you can do extra stuff first
            // should we first check all colGroups to make sure they're OK width?
            // instead... we'll check header heights for colGroups to since we have text-wrap on in those... and reset group header height if needed
            this.gridApi?.sizeColumnsToFit();  // will trigger updateRowHeights via event handler
        },
        async downloadSmartFormReplies() {
            // full SmartForm replies (incl. child forms, internal_only fields) as .xlsx from backend - one tab per vendor
            // only the latest reply from each vendor in this grid (rawReplies may be limited by responseIds prop)
            this.isDownloadingSmartFormReplies = true;
            try {
                const latestReplyIds = (this.rawReplies || []).filter(rep => rep.is_latest).map(rep => rep.id);
                const resp = await suppliosApi.smartForm.download_replies(this.smartFormData.id, latestReplyIds);
                const filetype = resp.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const blob = new Blob([resp.data], { type: filetype });
                // use the filename from the backend if we have it
                let rawFilename = `${this.title}_responses.xlsx`;
                const filenameMatch = (resp.headers['content-disposition'] || '').match(/filename="([^"]+)"/);
                if (filenameMatch && filenameMatch[1]) {
                    rawFilename = filenameMatch[1];
                }
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = sanitizeFilename(rawFilename);
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    link.remove();
                    window.URL.revokeObjectURL(url);
                }, 100);
            } catch (err) {
                this.apiErrorHandler(err, 'Failed to download responses');
            }
            this.isDownloadingSmartFormReplies = false;
        },
        exportExcel: function() {
            // use this.excelStyles to set styles for export, can re-use cellClassRules -- see docs
            const excelExportParams = {
                author: 'Supplios',
                fileName: 'export.xlsx',
                sheetName: 'Sheet1',  // there is a max of 31 characters for this
                //excelStyles: this.excelStyles,  // you are setting this at top-level right now...
                // processCellCallback: (params) => {
                //     //console.log('processCellCallback', params);
                //     return params.value;
                // },
                // TODO - do smarter number formatting for currency, etc. - currently the analysis cols are just stringified, not actually number values (should change that so they match the grid values)
                // TODO - skip over the 'chart button' col for quote sheets also
            };
            this.gridApi.exportDataAsExcel(excelExportParams);
        },
        togglePriceAnalysis: function() {
            const currentVisibility = this.showPriceAnalysis;
            this.gridColumnApi.setColumnsVisible([...this.priceAnalysisColKeys], !currentVisibility);
            this.showPriceAnalysis = !currentVisibility;  // toggle the actual data value
            this.sizeColumnsToFit();
        },
        getOrderedReplies(replyList) {
            // helper to pass in an array of replyObjects (must have .submitted_on) 
            // returns a new list ordered by submitted_on in DESCENDING order (latest first)
            const getSubmittedTimestamp = (replyObj) => {
                return DateTime.fromISO(replyObj.submitted_on).toSeconds();
            }
            return orderBy(replyList, [getSubmittedTimestamp], ['desc']);
        },
        getColIdsForReplyIds(replyIds, currentlySelectedVisible = true) {
            // return all the colIds for columns in this single replyId or array of replyIds
            // for most things, there is only one col per reply (no group col for reply) EXCEPT for QuoteSheet -- there are multiple colIds in one reply col group
            // this helps normalize that, used in methods below when showing/hiding latest/all replies
            // currentlySelectedVisible -- ONLY USED FOR QuoteSheets -- if true (default) then only return colIds that are currently visible based on check-box selections
            const replyIdList = Array.isArray(replyIds) ? [...replyIds] : [replyIds];
            const currentlySelectedVisibleKeys = this.quoteSheetVisibleVendorColIds;
            const colIds = [];
            replyIdList.forEach(repId => {
                const colIdsForReply = this.replyIdToColIds[repId];  // Array - NOT limited to only visible ones
                let visibleColIds = colIdsForReply; /// default to all colIds for this reply
                if (currentlySelectedVisible && this.category === 'quotesheet') {
                    visibleColIds = colIdsForReply.filter(colId => currentlySelectedVisibleKeys.some(k => colId.startsWith(`${k}_`)));
                }
                //colIds.push(...this.replyIdToColIds[repId]);
                colIds.push(...visibleColIds);
            });
            return colIds;
        },
        showAllReplies() {
            // show all replies for all companies?  or only visible companies?
            const allReplyIds = this.rawReplies.map(rep => rep.id);
            // updated to go through the same handler we use for checkbox toggles
            this.handleVisibleReplyColsChange(allReplyIds);
            // const allColIds = this.getColIdsForReplyIds(allReplyIds);
            // this.gridColumnApi.setColumnsVisible(allColIds, true);
            // this.sizeColumnsToFit();
        },
        hideAllReplies() {
            this.handleVisibleReplyColsChange([]);
        },
        showLatestReplies() {
            // show only latest replies for all companies?  or only visible companies?
            const companyIds = this.rawReplies.map(rep => rep.company_id);
            const companyIdsUnique = [...new Set(companyIds)];
            const latestReplyIds = [];
            companyIdsUnique.forEach(compId => {
                const compReplies = this.rawReplies.filter(rep => rep.company_id == compId);
                const orderedLatestFirst = this.getOrderedReplies(compReplies);
                const latest = orderedLatestFirst.map(rep => rep.id).slice(0, 1);  // an easy way to get the first item in an array, maybe empty if starting with empty array
                latestReplyIds.push(...latest);
            });
            // updated to go through the same handler we use for checkbox toggles
            this.handleVisibleReplyColsChange(latestReplyIds);
            // const hideReplyIds = this.rawReplies.map(rep => rep.id).filter(rId => !latestReplyIds.includes(rId));  // get all the replyIds, then filter out any that are latest ones
            // const latestColIds = this.getColIdsForReplyIds(latestReplyIds);
            // const hideColIds = this.getColIdsForReplyIds(hideReplyIds);
            // this.gridColumnApi.setColumnsVisible(latestColIds, true);
            // this.gridColumnApi.setColumnsVisible(hideColIds, false);
        },
        showOnlyLatestReplyForCompany(companyId) {
            // from clicking 'Show Latest' in the reply header - the @click is declared IN THE HEADER COMPONENT
            // find all the replies for this company, ONLY show the latest one by submitted_on date
            const companyReplies = this.rawReplies.filter(repObj => repObj.company_id == companyId);
            const orderedLatestFirstIds = this.getOrderedReplies(companyReplies).map(rep => rep.id);
            const showReplyIds = orderedLatestFirstIds.slice(0, 1);
            const hideReplyIds = orderedLatestFirstIds.slice(1);  // from index 1 until end 
            // updated to go through the same handler we use for checkbox toggles
            // remove any that we want to hide, then add the one we want to show if not already in the array
            const newVisibleReplyIds = this.visibleReplyIds.filter(vId => !hideReplyIds.includes(vId));
            if (!newVisibleReplyIds.includes(showReplyIds[0])) {
                newVisibleReplyIds.push(showReplyIds[0]);
            }
            this.handleVisibleReplyColsChange(newVisibleReplyIds);
            // const showColIds = this.getColIdsForReplyIds(showReplyIds);
            // const hideColIds = this.getColIdsForReplyIds(hideReplyIds);
            // this.gridColumnApi.setColumnsVisible(showColIds, true);
            // this.gridColumnApi.setColumnsVisible(hideColIds, false);
        },
        showAllRepliesForCompany(companyId) {
            // from clicking 'Show All' in the reply header - the @click is declared IN THE HEADER COMPONENT
            // find all the replies for this company and show all of them
            const companyReplies = this.rawReplies.filter(repObj => repObj.company_id == companyId);
            const companyReplyIds = companyReplies.map(rep => rep.id);
            // updated to go through the same handler we use for checkbox toggles
            const newVisibleReplyIds = Array.from(new Set([...this.visibleReplyIds, ...companyReplyIds]));
            this.handleVisibleReplyColsChange(newVisibleReplyIds);
            // const colIds = this.getColIdsForReplyIds(companyReplyIds);
            // this.gridColumnApi.setColumnsVisible(colIds, true);
        },
        openActionModal: function(companyId, initialTab) {
            // this is called by components in the grid (colGroupHeader component) to open the modal to manage RfxResponse or other things for a vendor/reply in the grid
            // let the parent component figure out how to handle this, depending on the use case
            this.$devlog('from openActionModal, payload is');
            this.$devlog(companyId, initialTab);
            this.$emit('open-action', companyId, initialTab);
        },
        getStandardColDefsSmartForm: function() {
            // build and return the colDefs array used for any smartform 
            const standardCols = [
                /* {   // NEED THIS - this is how row grouping is actually done -- by groupId (or whatever other field you want for grouping)
                    // hide: true // rowGroup: true  -- don't need to show it, but need it for grouping since we have all info on each line, and we have hide open parents
                    // this way you can have one PRODUCT on here multiple times, but variants are grouped separately because grouping is by QuoteSheetItem ID (QsItemForReply), not product ID
                    headerName: '',
                    field: 'group_label',  // was 'groupId' but now we'll group by parent in the form
                    hide: true,  // was true
                    rowGroup: true,  // should be true if no treeData, but no col at all if using treeData with auto group col
                    headerClass: 'pl-3',
                    suppressColumnsToolPanel: true,
                    //cellRenderer:'agGroupCellRenderer',
                    //cellRendererParams: {
                    //    suppressCount: true,
                    //    checkbox: false,
                    //},
                    //valueGetter: (params) => { return params.data ? params.data.group_label : ''},
                }, */
                /* {
                    headerName: 'Item',
                    field: 'smartform_data',
                    suppressColumnsToolPanel: false,  // hide from cols tool panel
                    chartDataType: 'category',
                    pinned: false,
                    filter: true,
                    //rowGroup: true,
                    //type: ['noEditCol'],
                    minWidth: 120,
                    maxWidth: 300,
                    cellStyle: {
                        'font-weight': 'bold',
                    },
                    headerClass: ['pl-3'],
                    cellClass: ['pl-3', 'cell-muted', 'smartform-item'],
                    cellRenderer: 'smartFormItemCellRenderer',
                    //cellRendererParams: {
                    //    padding: verticalPadding,
                    //},
                    valueGetter: (params) => {return params.data ? params.data.label : ''},
                }, */
            ];
            return standardCols;
        },
        getStandardColDefsFormiumForm: function() {
            const standardCols = [
                {   // NEED THIS - this is how row grouping is actually done -- by groupId, which is the ID of the ITEM for each line
                    // hide: true // rowGroup: true  -- don't need to show it, but need it for grouping since we have all info on each line, and we have hide open parents
                    // this way you can have one PRODUCT on here multiple times, but variants are grouped separately because grouping is by QuoteSheetItem ID (QsItemForReply), not product ID
                    headerName: 'Group Manual',
                    field: 'groupId',
                    hide: true,
                    rowGroup: true,
                    headerClass: 'pl-3',
                    suppressColumnsToolPanel: true,
                    cellRenderer:'agGroupCellRenderer',
                    cellRendererParams: {
                        suppressCount: true,
                        checkbox: false,
                    },
                },
                {
                    headerName: 'Questions',
                    field: 'formiumItem',
                    suppressColumnsToolPanel: false,  // hide from cols tool panel
                    pinned: true,
                    filter: true,
                    //rowGroup: true,
                    //type: ['noEditCol'],
                    minWidth: 120,
                    maxWidth: 300,
                    cellStyle: {
                        'font-weight': 'bold',
                    },
                    headerClass: ['pl-3'],
                    cellClass: ['pl-3', 'cell-muted'],
                    /*
                    cellRenderer: 'dynamicPaddingRenderer',
                    cellRendererParams: {
                        padding: verticalPadding,
                    },*/
                    valueGetter: (params) => {return params.data ? params.data.label : ''},
                },
            ];
            return standardCols;
        },
        getStandardColDefsDocRequest: function() {
            const standardCols = [
                {   // NEED THIS - this is how row grouping is actually done -- by groupId, which is the ID of the ITEM for each line
                    // hide: true // rowGroup: true  -- don't need to show it, but need it for grouping since we have all info on each line, and we have hide open parents
                    // this way you can have one PRODUCT on here multiple times, but variants are grouped separately because grouping is by QuoteSheetItem ID (QsItemForReply), not product ID
                    headerName: 'Group Manual',
                    field: 'groupId',
                    hide: true,
                    rowGroup: true,
                    headerClass: 'pl-3',
                    suppressColumnsToolPanel: true,
                    cellRenderer:'agGroupCellRenderer',
                    cellRendererParams: {
                        suppressCount: true,
                        checkbox: false,
                    },
                },
                {
                    headerName: 'Document Info',
                    field: 'docrequest_info',
                    suppressColumnsToolPanel: false,  // hide from cols tool panel
                    pinned: true,
                    filter: true,
                    //rowGroup: true,
                    //type: ['noEditCol'],
                    minWidth: 120,
                    maxWidth: 300,
                    cellStyle: {
                        'font-weight': 'bold',
                    },
                    headerClass: ['pl-3'],
                    cellClass: ['pl-3', 'cell-muted'],
                    /*
                    cellRenderer: 'dynamicPaddingRenderer',
                    cellRendererParams: {
                        padding: verticalPadding,
                    },*/
                    valueGetter: (params) => {return params.data ? params.data.label : ''},
                },
            ];
            return standardCols;
        },
        getStandardColDefsQuoteSheet: function() { // function to put at bottom to just return standard colDefs
            //let rowCount = this.rowData.length;
            //let verticalPadding = rowCount < 20 ? (rowCount < 8 ? '25px' : '15px') : '10px';
            const itemDetailsColsHidden = {  // centralize logic for which are hidden here so we know how many to span for grand total row
                itemName: (this.quoteSheetData.internalCols.show_name === false),
                partNumber: (this.quoteSheetData.internalCols.show_part_number === false),
                itemDescription: (this.quoteSheetData.internalCols.show_description === false),
                variantDescription: !this.hasMultipleVariants,
                needByDate: (this.quoteSheetData.internalCols.show_need_by_date === false),
            };
            const itemDetailsVisibleColCount = Object.values(itemDetailsColsHidden).filter(isHiddenValue => !isHiddenValue).length;  // this is how many to span for GRAND TOTAL colSpan
            const firstVisibleItemDetailsColKey = Object.entries(itemDetailsColsHidden).find(([k, isHidden]) => (!!k && !isHidden))?.[0];  // !!k is just to make linter happy.... returns the KEY ('itemName', 'partNumber', etc.) of first VISIBLE col in item details
            const itemDetailsColSpanCallback = (params) => {  // return the NUMBER of cols to span (should be 1 for normal case)
                return params.data.isGrandTotalRow ? (params.column.colId === firstVisibleItemDetailsColKey ? itemDetailsVisibleColCount : 1) : 1;
            };
            const standardCols = [
                {   // NEED THIS - this is how row grouping is actually done -- by groupId, which is the ID of the ITEM for each line
                    // hide: true // rowGroup: true  -- don't need to show it, but need it for grouping since we have all info on each line, and we have hide open parents
                    // this way you can have one PRODUCT on here multiple times, but variants are grouped separately because grouping is by QuoteSheetItem ID (QsItemForReply), not product ID
                    headerName: 'Group Manual',
                    field: 'groupId',
                    hide: true,
                    rowGroup: true,
                    headerClass: 'pl-3',
                    suppressColumnsToolPanel: true,
                    cellRenderer:'agGroupCellRenderer',
                    cellRendererParams: {
                        suppressCount: true,
                        checkbox: false,
                    },
                },
                /* {  // you COULD use these to manually show group columns, have to use these settings:
                        // groupSuppressAutoColumn: true,
                        // groupMultiAutoColumn: true,
                        // groupHideOpenParents: true, 
                        // and rowGroup: true / hide: true on all the 'regular' columns for these
                    headerName: 'Item',
                    colId: 'item_group',
                    minWidth: 200,
                    showRowGroup: 'itemName',
                    cellStyle: {
                        'font-weight': 'bold',
                    },
                },
                {
                    headerName: 'Part Number',
                    minWidth: 200,
                    showRowGroup: 'partNumber',
                },
                {
                    headerName: 'Item Description',
                    minWidth: 200,
                    showRowGroup: 'itemDescription',
                }, */

                // ADD colSpan callback for our EXTRA GRAND TOTAL row - but need to adapt to which cols are visible
                 {
                    headerName: 'Item Details',
                    groupId: 'quotesheet_item_details',
                    marryChildren: true,
                    suppressMovable: true,
                    headerTooltip: 'Item Details',
                    children: [
                        {
                            headerName: 'Item Name',
                            field: 'itemName',
                            hide: itemDetailsColsHidden['itemName'],
                            suppressColumnsToolPanel: itemDetailsColsHidden['itemName'],
                            suppressFiltersToolPanel: itemDetailsColsHidden['itemName'],
                            colSpan: itemDetailsColSpanCallback,
                            pinned: true,
                            filter: true,
                            //rowGroup: true,
                            type: ['firstChildVisible'],
                            minWidth: 100,
                            maxWidth: 250,
                            cellStyle: {
                                'font-weight': 'bold',
                            },
                            headerClass: ['pl-3'],
                            cellClass: ['viz-col', 'pl-3', 'cell-muted'],
                            /*
                            cellRenderer: 'dynamicPaddingRenderer',
                            cellRendererParams: {
                                padding: verticalPadding,
                            },*/
                            valueGetter: (params) => {
                                return params.data ? (params.data.isGrandTotalRow ? 'GRAND TOTAL' : params.data.itemName) : '';
                            },
                        },
                        {
                            headerName: 'Part Number',
                            field: 'partNumber', 
                            hide: itemDetailsColsHidden['partNumber'],
                            suppressColumnsToolPanel: itemDetailsColsHidden['partNumber'],
                            suppressFiltersToolPanel: itemDetailsColsHidden['partNumber'],
                            colSpan: itemDetailsColSpanCallback,
                            pinned: true,
                            filter: true,
                            //rowGroup: true,
                            type: ['firstChildVisible'],
                            cellClass: ['cell-muted'],
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {
                                return params.data ? (params.data.isGrandTotalRow ? 'GRAND TOTAL' : params.data.partNumber) : '';
                            },
                        },
                        {
                            headerName: 'Item Description',
                            field: 'itemDescription', 
                            hide: itemDetailsColsHidden['itemDescription'],
                            suppressColumnsToolPanel: itemDetailsColsHidden['itemDescription'],
                            suppressFiltersToolPanel: itemDetailsColsHidden['itemDescription'],
                            colSpan: itemDetailsColSpanCallback,
                            pinned: true,
                            filter: true,
                            //rowGroup: true,
                            type: ['firstChildVisible'],
                            cellClass: ['cell-muted'],
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {
                                return params.data ? (params.data.isGrandTotalRow ? 'GRAND TOTAL' : params.data.item.description) : '';
                            },
                        },
                        {
                            headerName: 'Variant Description',
                            field: 'variantDescription',
                            pinned: true,
                            //type: [],
                            filter: true,
                            cellClass: ['cell-muted', 'variant-indicator-col'],
                            hide: itemDetailsColsHidden['variantDescription'],
                            suppressColumnsToolPanel: itemDetailsColsHidden['variantDescription'],
                            suppressFiltersToolPanel: itemDetailsColsHidden['variantDescription'],
                            //colSpan: itemDetailsColSpanCallback,  // don't need this here??? should never be the first col... if you do, need to also change valueGetter
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {return params.data ? params.data.variant.description : ''},
                        },
                        {
                            headerName: 'Need by Date',
                            field: 'needByDate',
                            pinned: true,
                            //type: [],
                            filter: true,
                            cellClass: ['cell-muted', 'variant-indicator-col'],
                            hide: itemDetailsColsHidden['needByDate'],
                            suppressColumnsToolPanel: itemDetailsColsHidden['needByDate'],
                            suppressFiltersToolPanel: itemDetailsColsHidden['needByDate'],
                            //colSpan: itemDetailsColSpanCallback,  // don't need this here??? should never be the first col... if you do, need to also change valueGetter
                            minWidth: 100,
                            maxWidth: 250,
                            valueGetter: (params) => {return params.data ? params.data.variant.need_by_date : ''},
                            valueFormatter: agDateFormatter,
                        },
                     ],
                },
                {
                    headerName: 'Quantity',
                    groupId: 'quotesheet_quantity',
                    marryChildren: true,
                    suppressMovable: true,
                    headerTooltip: 'Quantity Information',
                    children: [
                        {
                            headerName: 'Quantity',
                            field: 'quantity', 
                            hide: this.quoteSheetData.internalCols.show_quantity === false,
                            suppressColumnsToolPanel: this.quoteSheetData.internalCols.show_quantity === false,
                            suppressFiltersToolPanel: this.quoteSheetData.internalCols.show_quantity === false,
                            pinned: true,
                            filter: true,
                            // REMOVED type: ['quantityCol', 'noEditCol'],
                            headerClass: ['column-align-right'],
                            cellClass: ['cell-muted', 'column-align-right'],
                            minWidth: 80,
                            maxWidth: 120,
                            valueGetter: variantGetter,
                            valueFormatter: agNumberFormatter,
                        },
                        {
                            headerName: 'UoM',
                            field: 'uom',
                            hide: this.quoteSheetData.internalCols.show_uom === false,
                            suppressColumnsToolPanel: this.quoteSheetData.internalCols.show_uom === false,
                            suppressFiltersToolPanel: this.quoteSheetData.internalCols.show_uom === false,
                            pinned: true,
                            filter: true,
                            // REMOVED type: ['quantityCol', 'noEditCol'],
                            cellClass: ['cell-muted'],
                            minWidth: 80,
                            maxWidth: 120,
                            valueGetter: variantGetter,
                        },
                        {
                            headerName: 'Timeframe',
                            field: 'quantity_timeframe',
                            hide: this.quoteSheetData.internalCols.show_timeframe === false,
                            suppressColumnsToolPanel: this.quoteSheetData.internalCols.show_timeframe === false,
                            suppressFiltersToolPanel: this.quoteSheetData.internalCols.show_timeframe === false,
                            pinned: true,
                            filter: true,
                            // REMOVED type: ['quantityCol', 'noEditCol'],
                            cellClass: ['cell-muted'],
                            minWidth: 100,
                            maxWidth: 140,
                            valueGetter: variantGetter,
                        },
                    ],
                },
                {
                    headerName: 'Reference Prices',
                    groupId: 'quotesheet_ref_prices',
                    marryChildren: true,
                    suppressMovable: true,
                    headerTooltip: 'Reference Prices',
                    children: [
                        {
                            headerName: 'Current Price',
                            field: 'current_price', 
                            hide: this.quoteSheetData.internalCols.show_current_price === false,
                            suppressColumnsToolPanel: this.quoteSheetData.internalCols.show_current_price === false,
                            suppressFiltersToolPanel: this.quoteSheetData.internalCols.show_current_price === false,
                            pinned: true,
                            filter: true,  // false?
                            headerClass: ['column-align-right'],
                            cellClass: ['cell-muted', 'column-align-right'],
                            minWidth: 80,
                            maxWidth: 120,
                            valueGetter: variantGetter,  // gets from 'current_price' on the variant
                            valueFormatter: (params) => {
                                let rawAmount = toNumberOrNull(params.value);
                                let currencyCode = params.data?.current_price_currency || this.quoteSheetData.currency;  // use the currency on the row if available, otherwise default to quoteSheet currency
                                // CLEVER, but not needed... we have something similar built-in to formatMoney: let decimalPlaces = hasValueOrZero(rawAmount) && rawAmount % 1 === 0 ? 0 : 4;  // if whole number, show 0 decimal places, otherwise 4
                                const decimalPlaces = 4;
                                return hasValueOrZero(rawAmount) ? formatMoney(rawAmount, currencyCode, decimalPlaces) : '';  // formatMoney will return '' if amount is null or undefined
                            },
                        },
                        {
                            headerName: 'Target Price',
                            field: 'target_price', 
                            hide: this.quoteSheetData.internalCols.show_target_price === false,
                            suppressColumnsToolPanel: this.quoteSheetData.internalCols.show_target_price === false,
                            suppressFiltersToolPanel: this.quoteSheetData.internalCols.show_target_price === false,
                            pinned: true,
                            filter: true,  // false?
                            headerClass: ['column-align-right'],
                            cellClass: ['cell-muted', 'column-align-right'],
                            minWidth: 80,
                            maxWidth: 120,
                            valueGetter: variantGetter,  // gets from 'target_price' on the variant
                            valueFormatter: (params) => {
                                let rawAmount = toNumberOrNull(params.value);
                                let currencyCode = params.data?.target_price_currency || this.quoteSheetData.currency;  // use the currency on the row if available, otherwise default to quoteSheet currency
                                // CLEVER, but not needed... we have something similar built-in to formatMoney: let decimalPlaces = hasValueOrZero(rawAmount) && rawAmount % 1 === 0 ? 0 : 4;  // if whole number, show 0 decimal places, otherwise 4
                                const decimalPlaces = 4;
                                return hasValueOrZero(rawAmount) ? formatMoney(rawAmount, currencyCode, decimalPlaces) : '';  // formatMoney will return '' if amount is null or undefined
                            },
                        },
                    ],
                },
                {  // just for generating the charts
                    headerName: '',
                    headerTooltip: 'Generate chart for all bids for this line item',
                    headerComponent: 'quoteSheetRowChartHeaderRenderer',
                    headerClass: ['column-align-center'],
                    cellRenderer: 'quoteSheetRowChartCellRenderer',
                    field: 'quotesheet_price_chart_col',
                    colId: 'quotesheet_price_chart_col',  // need this???
                    cellClass: ['cell-muted', 'column-align-center'],
                    pinned: true,
                    hide: false,
                    minWidth: 35,
                    maxWidth: 35,
                },
            ];
            // build up the cols for checkbox toggles
            // NOTE: we are skipping over the 'chart button' col for this.... it is always shown -- change if needed later
            const availableStandardCols = [];
            standardCols.forEach(colGroup => {
                if (colGroup.children) {
                    const availableChildren = colGroup.children.filter(col => !col.hide).map(c => ({value: c.field, text: c.headerName}));
                    availableChildren.forEach(col => {
                        availableStandardCols.push(col);
                    });
                }
            });
            this.quoteSheetAvailableItemCols = availableStandardCols;
            this.quoteSheetVisibleItemColIds = availableStandardCols.map(c => c.value);  // start with all checked
            return standardCols;
        },
        buildQuoteSheetAnalysisColDefs: function() {
            // build colDefs for max/min/mean, etc. only for QuoteSheet
            let priceAnalysisColDefs = [
                {
                    headerName: 'Price Analysis',
                    groupId: 'price_analysis_columns',  // this is how you get colGroups using this.gridColumnApi
                    headerGroupComponent: 'analysisColGroupHeader',
                    headerGroupComponentParams: {
                        subheading: 'Only includes the LATEST responses from each vendor.',
                    },
                    marryChildren: true,
                    children: [
                        {
                            headerName: 'Low',
                            headerTooltip: 'Lowest price from all bids on this line',
                            type: ['priceAnalysisCol'],
                            field: ANALYSIS_COL_KEYS.min,
                            colId: ANALYSIS_COL_KEYS.min,  // need to explicitly define this becuase we use it some places when applying cellClassRules
                            cellClass: ['is-min-price', 'column-align-right', 'analysis-col'],
                            hide: false,  // make this a function, put it on type?  for now just default to false
                        },
                        {
                            headerName: 'Average',
                            headerTooltip: 'Average (mean) price from all bids on this line',
                            type: ['priceAnalysisCol'],
                            field: ANALYSIS_COL_KEYS.mean,
                            colId: ANALYSIS_COL_KEYS.mean,  // need to explicitly define this becuase we use it some places when applying cellClassRules
                            cellClass: ['column-align-right', 'analysis-col'],
                            hide: false,
                        },
                        {
                            headerName: 'High',
                            headerTooltip: 'Highest price from all bids on this line',
                            type: ['priceAnalysisCol'],
                            field: ANALYSIS_COL_KEYS.max,
                            colId: ANALYSIS_COL_KEYS.max,  // need to explicitly define this becuase we use it some places when applying cellClassRules
                            cellClass: ['is-max-price', 'column-align-right', 'analysis-col'],
                            hide: false,
                        },
                    ],
                },
            ];
            // set the stuff for checkbox toggles
            this.availableAnalysisCols = priceAnalysisColDefs[0].children.map(c => ({value: c.field, text: c.headerName}));
            this.visibleAnalysisColIds = priceAnalysisColDefs[0].children.filter(c => !c.hide).map(c => c.field);  // start with all checked);
            return priceAnalysisColDefs;
        },
        buildSmartFormAnalysisColDefs: function() {
            // build colDefs for max/min/mean, etc. only for QuoteSheet
            let priceAnalysisColDefs = [
                {
                    headerName: 'Analysis',
                    groupId: 'price_analysis_columns',  // this is how you get colGroups using this.gridColumnApi
                    headerGroupComponent: 'analysisColGroupHeader',
                    headerGroupComponentParams: {
                        subheading: 'Only includes the LATEST responses from each vendor.',
                    },
                    marryChildren: true,
                    children: [
                        {
                            headerName: 'Low',
                            headerTooltip: 'Lowest price from all bids on this line',
                            type: ['priceAnalysisCol'],
                            field: ANALYSIS_COL_KEYS.min,
                            colId: ANALYSIS_COL_KEYS.min,  // need to explicitly define this becuase we use it some places when applying cellClassRules
                            cellClass: ['is-min-price', 'column-align-center', 'analysis-col'],
                            hide: false,  // make this a function, put it on type?  for now just default to false
                        },
                        {
                            headerName: 'Average',
                            headerTooltip: 'Average (mean) price from all bids on this line',
                            type: ['priceAnalysisCol'],
                            field: ANALYSIS_COL_KEYS.mean,
                            colId: ANALYSIS_COL_KEYS.mean,  // need to explicitly define this becuase we use it some places when applying cellClassRules
                            cellClass: ['column-align-center', 'analysis-col'],
                            hide: false,
                        },
                        {
                            headerName: 'High',
                            headerTooltip: 'Highest price from all bids on this line',
                            type: ['priceAnalysisCol'],
                            field: ANALYSIS_COL_KEYS.max,
                            colId: ANALYSIS_COL_KEYS.max,  // need to explicitly define this becuase we use it some places when applying cellClassRules
                            cellClass: ['is-max-price', 'column-align-center', 'analysis-col'],
                            hide: false,
                        },
                    ],
                },
            ];
            // set the stuff for checkbox toggles
            this.availableAnalysisCols = priceAnalysisColDefs[0].children.map(c => ({value: c.field, text: c.headerName}));
            this.visibleAnalysisColIds = priceAnalysisColDefs[0].children.filter(c => !c.hide).map(c => c.field);  // start with all checked);
            return priceAnalysisColDefs;
        },
    }
}
</script>

<style lang="scss">
@import "../../css/supplios-ag-grid-mixins.scss";  // need this to get the ag-rowgroup-indicators mixin

.company-todo-compare-grid-toggles {
    // had these originally: d-flex flex-wrap gap-5 align-items-start justify-content-start
    // but we will show groups stacked now, and checkboxes inline
    .toggle-group {
        width: 100%;
        padding: 0;
        border-bottom: 1px solid var(--gray-300);
        //display: flex;
        //column-gap: 1rem;
        &:last-of-type {
            border-bottom: none;
        }
        .toggle-heading {
            //width: 20%;
            //max-width: 200px;
            padding: 0;
            text-align: left;
        }
        .toggle-group-collapse-button {   // special-text text-muted font-size-80 mb-1
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: var(--gray-100);
            padding: 0.75rem 1rem;
            text-align: left;
            &.collapsed .when-open,
            &.not-collapsed .when-closed {
                display: none;
            }
            .collapse-button-text {
                font-size: 0.8rem;
                text-transform: uppercase;
                font-weight: 500;
            }
            &:hover {
                background-color: var(--gray-200);
            }
        }
        .toggle-group-collapse {
            padding:0 0 0 1rem;  // do not put vertical padding here, it screws up closing of the collapse area
        }
        .compare-grid-toggle-checkboxes {
            max-height: 400px;
            overflow-y: auto;  // so we get scrollbars in each 'section' if needed
            overflow-x: hidden;
            margin-bottom: 1rem;
            .custom-checkbox {
                .custom-control-label {
                    font-size: 0.8rem;
                    vertical-align: baseline;  // makes the labels not align to the top of the checkbox
                    font-weight: 500;
                }
            }
        }
        .show-hide-links {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            padding-right: 1rem;
            // left side aleady has padding from the collapse area
            display: flex;
            column-gap: 1rem;
            align-items: baseline;
            justify-content: flex-start;
        }
        .show-hide-toggle-link {
            cursor: pointer;
            font-size: 0.8rem;
            font-weight: 500;
            color: var(--primary-700);
            &.disabled {
                color: var(--gray-400);
                &:hover {
                    cursor: default;
                    text-decoration: none;
                }
            }
        }
    
    }

    hr {
        margin: 0;  // we have enough vertical margin from the toggle-group padding
    }
}

.company-todo-compare-grid {

    .ag-header {

        .ag-header-row {

            .ag-header-group-cell {
                background-color: var(--gray-100);
                &.vendor-col {background-color: var(--primary-50);}
                &.reply-group-header .ag-header-group-cell-label .ag-header-group-text {
                    font-size: 12px;  // normally header cells are bigger font, but this isn't really a header... its the extra colGroup we have for quotesheets
                    white-space: normal;
                    text-align: center;
                }
            }
            .ag-header-cell {
                background-color: var(--gray-150);
                &.vendor-col {
                    background-color: var(--primary-100);
                }
            }
            /* .company-group-header,
            .reply-group-header,
            .quotesheet-vcol-header:first-of-type {
                border-left: 1px solid var(--gray-800);
            } */
            /* .company-group-header:last-of-type,
            .reply-group-header:last-of-type,
            .quotesheet-vcol-header:last-of-type {
                border-right: 1px solid var(--gray-800);
            } */
        }
    }

    .ag-pinned-left-cols-container {
        @include ag-rowgroup-indicators;  // big mixin that does all the item/variant visual indicators
    }

    .ag-row {

        &.item-lastrow:not(.docrequest) {border-bottom-color: var(--gray-600);}  // darker border for better visual of groups - NOT RELATED TO INDICATORS
        // skipping it for .docrequest
        // FYI - this gets applied to the last row OF EACH LEVEL if you use treeData, like in SmartForms
        
        .ag-cell {
            &.vendor-col.first-col-in-group:not(.ag-cell-focus),
            &.analysis-col.first-col-in-group:not(.ag-cell-focus) {border-left-color: black;}
            &.formium-value {  // moved this to cellRenderer for formium values
                white-space: pre-wrap;  // needed to display textareas with breaks correctly and seems to not harm others
                padding-top: 1rem;
                padding-bottom: 1rem;
            }
            &.docrequest-data {  // you also have padding/styles in the custom renderer component
                padding-top: 1rem;
                padding-bottom: 1rem;
            }
        }

    }

    // CELL-BACKGROUND COLORS - need to put them in .ag-row:not(.ag-row-hover)
    .ag-row:not(.ag-row-hover) {
        .ag-cell {
            &.is-min-price {background-color: var(--success-50);}
            &.is-max-price {background-color: var(--danger-50);}
            &.previous {background-color: var(--gray-100);}
        }
    }

    // SPECIFIC TO SmartForms 
    .smartform.ag-row:not(.ag-row-hover) {  // HOVER COLORS

        &.is-calculated .ag-cell.smartform-item {
            // no longer highlighting the calculated ones... seems silly... use it for emphasis instead
            //background-color: var(--primary-50);  // had info-50 before, but that was same color as internal_only in smartform view
        }
        &.emphasis .ag-cell.smartform-item {
            background-color: var(--primary-100);  
        }
        &.is-reply-input .ag-cell.smartform-item {
            background-color: var(--warning-100);
        }
        .ag-cell.analysis-col {
            background-color: var(--gray-100);
        }
        &.smartform-show-analysis .ag-cell.analysis-col {
            &.is-min-price {background-color: var(--success-50);}
            &.is-max-price {background-color: var(--danger-50);}
        }

        &.ag-row-group {  // .ag-row-group is only on the rows that have children... ie: the 'group' row
            border-bottom-color: transparent;  // make sure they don't have the extra dark bottom borders
            .ag-cell {  
                background-color: var(--gray-150);
            }
            &.ag-row-level-0 {
                // make the top-most rows in hierarchy darker - and more obvious font/text
                .ag-cell {
                    background-color: var(--gray-300);
                    font-size: 1rem;
                    color: var(--primary-700);
                }
            }
            &.ag-row-level-1 {
                // should only be applied if its a group row... not if its an actual data row 
                .ag-cell {
                    font-size: 0.9rem;
                    color: var(--primary-700);
                    font-style: italic;
                }
            }
        }
    }
    .smartform.ag-row {  // any row in a smartform
        .ag-cell-wrapper.ag-row-group-leaf-indent {  // the group cell, with treeData
            .ag-group-value {  // the value thing... our custom vue component is inside this
                width: 100%;
            }
        }
    }

    // GRAND TOTALS - override other formatting, so end  (for QuoteSheets)
    .ag-row.grand-total-row {  // not hover?
        .ag-cell, .ag-cell.cell-muted, .ag-cell.previous {
            background-color: var(--gray-200);
            font-weight: 700;
        }
    }



}

</style>